<member-level *ngIf="showMemberLevel"  [review]="reviewModel"></member-level>
<!-- Unlock Account Modal -->
<modal #resetPassword>
    <modal-header>
        <div class="color-blue">{{'customer-service.RESET PASSWORD' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail?.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="reset-password-content">
            <form [formGroup]="resetPasswordForm" id="reset-password-form">
                <div class="col-md-12 pad-t-50">
                    <input id="temporaryPassword" formControlName="resetPassword" name="resetPassword" value="1"
                        type="radio">
                    <label for="temporaryPassword"><b class="bold">{{'customer-service.Temporary Password' |translate
                            |translateKey}}:&nbsp;</b>{{tempPassword}}</label>
                </div>
                <div class="col-md-12 pad-t-b-20-50">
                    <input id="resetPasswordMail" formControlName="resetPassword" name="resetPassword" value="2"
                        type="radio">
                    <label for="resetPasswordMail">{{'customer-service.Send email with Password Reset Link' |translate
                        |translateKey}}</label>
                </div>
            </form>
        </div>
        <div class="pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="submit" [attr.disabled]="tempPassword?null:''"
                (click)="updateTemporaryPassword()">
                {{'config-system.UPDATE' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforResetPassword()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>

<!--FLP360 Password reset Modal-->
<modal #resetFlp360Password>
    <modal-header>
        <div class="color-blue">{{'customer-service.FLP360 RESET PASSWORD' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="reset-password-content">
            <form [formGroup]="flp360ResetPasswordForm" id="flp360-reset-password-form">
                <div class="col-md-12 pad-t-50">
                    <input id="flp360TemporaryPassword" formControlName="flp360ResetPassword" name="flp360ResetPassword"
                        value="1" type="radio">
                    <label for="flp360TemporaryPassword"><b class="bold">{{'customer-service.Temporary Password'
                            |translate |translateKey}}:&nbsp;</b>{{tempPassword}}</label>
                </div>
                <div class="col-md-12 pad-t-b-20-50">
                    <input id="flp360ResetPasswordMail" formControlName="flp360ResetPassword" name="flp360ResetPassword"
                        value="2" type="radio">
                    <label for="flp360ResetPasswordMail">{{'customer-service.Send email with Password Reset Link'
                        |translate |translateKey}}</label>
                </div>
            </form>
        </div>
        <div class="pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="submit" [attr.disabled]="tempPassword?null:''"
                (click)="updateFlp360TemporaryPassword()">
                {{'config-system.UPDATE' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeFlp360ResetPasswordModal()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>

<!-- Unlock Account Modal -->
<modal #unlock>
    <modal-header>
        <div class="color-blue">{{'customer-service.UNLOCK ACCOUNT' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="unlockForm" [formGroup]="unlockForm" (ngSubmit)="saveUnLockInfo()" class="col-xs-12" novalidate>
            <div>
                <table class="mt-10">
                    <thead>
                        <tr>
                            <th class="width-120">
                                <strong>{{'customer-service.Date' |translate | translateKey}}</strong>
                            </th>
                            <th>{{'ticketing-system.Reset Notes' |translate | translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="unLockData.length >0">
                        <tr *ngFor="let data of unLockData">
                            <td>{{data.createdDate | date: 'dd-MMM-yyyy'}}</td>
                            <td>{{data.comments}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="floating-input floatLabelContainer mt-20">
                    <textarea #createNotesInput id="createNotesInput" float-label class="form-control overflow-x-hidden"
                        formControlName="unlockAccountMessage" placeholder="{{'ticketing-system.Notes'|translate}}"
                        rows="5"></textarea>
                    <div class="alert-msg"
                        *ngIf="!unlockForm.controls['unlockAccountMessage'].valid && unlockForm.controls['unlockAccountMessage'].hasError('required') &&(unlockForm.controls['unlockAccountMessage'].touched|| isUnLockSubmitted)">
                        {{'validation-message.Required'|translate | translateKey}}
                    </div>
                </div>
            </div>

            <div class="pull-right pad-r-8" *ngIf="isAccountLocked">
                <button class="btn blue-button" tabindex="0" type="submit">
                    {{'customer-service.UNLOCK' |translate}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'customer-service.CANCEL' |translate}}
                </button>
            </div>
            <div class="pull-right pad-r-8" *ngIf="!isAccountLocked">
                <button class="btn blue-button" tabindex="0" type="submit" disabled>
                    {{'customer-service.UNLOCK' |translate}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'customer-service.CANCEL' |translate}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>
<!-- Change Home Country Modal -->
<ng-template #changeHomeCountry>
    <div class="modal-header">
        <div class="color-blue">{{'customer-service.CHANGE ADDRESS' |translate |translateKey}}</div>
    </div>
    <div class="modal-body" *ngIf="fboProfileDetail?.address && mailingSchemaUrl">
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="changeaddress-form">
            <app-address-new (addressSubmit)="getNewAddressInfo($event)" class="mailing-address-form"
                (cancelChangeAddress)="bsModalRef.hide()"
                (isDisplaySearchAddressSection)="displaySearchAddressSection($event)"
                [skipAddressVerification]="appConfig?.skipAddressVerification" [schemaClass]="'mailing-address-form'"
                [countryCode]="selectedCountry" [schemaUrl]="mailingSchemaUrl"
                [preloadAddress]="addressDetail" [isFromFboProfile]="true"
                [isChangeRegisteredAddress]="true" [storeConfig]="storeInfo"></app-address-new>
        </div>
        <div class="px-0 py-3 set-default-address col-6" *ngIf="isDisplaySearchAddressSection">
            <span>{{'checkout.Don’t see a match?' | translate | translateKey}}</span>
            <span (click)="enableAddressFields('mailing-address-form')"><a class="link--light"
                    tabindex="0">{{'checkout.Click here' | translate | translateKey}}</a></span>
            <span>{{'checkout.to enter address' | translate | translateKey}}</span>
        </div>
    </div>
</ng-template>

<!-- Change Status Modal -->
<modal #changeStatus>
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE STATUS' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="statusForm" [formGroup]="statusForm" (ngSubmit)="ChangeStatusSubmit()" class="col-xs-12"
            novalidate>
            <div class="modalcontent-section changeStatus">
                <div class="row">
                    <div class="col-md-6 floating-input">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="newstatus">
                            <option disabled value="">{{'customer-service.New Status' |translate |translateKey}}
                            </option>
                            <option *ngFor="let status of statusDropdownItems" [ngValue]="status.id">{{status.value}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!statusForm.controls['newstatus'].valid && (statusForm.controls['newstatus'].touched)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isSuspendedStatus">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input [owlDateTime]="dt2" class="form-control"
                            placeholder="{{'customer-service.End Date dd-mmm-yyyy'|translate | translateKey}}"
                            formControlName="endDate" maxlength="11" float-label DateFormat
                            (blur)="statusChangeTransformDate(statusForm.controls['endDate'].value)">
                        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt2></owl-date-time>
                        <span class="" [owlDateTimeTrigger]="dt2">
                            <span class="fa fa-calendar calendar-icon-fbo select-pointer"></span>
                        </span>
                        <div class="alert-msg"
                            *ngIf="!statusForm.controls['endDate'].valid && statusForm.controls['endDate'].hasError('Required')&& (statusForm.controls['endDate'].touched)">
                            {{'order.Required' |translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!statusForm.controls['endDate'].valid && statusForm.controls['endDate'].hasError('dateValidation')">
                            {{'validation-message.Enter valid Date'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!statusForm.controls['endDate'].valid && statusForm.controls['endDate'].hasError('lessThanOrEqualToCurrentDate') && !statusForm.controls['endDate'].hasError('dateValidation')">
                            {{'validation-message.Should be greater than current Date'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <div *ngIf="statusChanged" class="floating-input floatLabelContainer textarea-msg">
                    <textarea float-label tabindex="0" id="notes-input" class="form-control overflow-x-hidden"
                        formControlName="notes" placeholder="{{'ticketing-system.Notes'|translate}}"
                        rows="5"></textarea>

                    <div class="alert-msg"
                        *ngIf="!statusForm.controls['notes'].valid  && statusForm.controls['notes'].hasError('required') && (statusForm.controls['notes'].touched || isSubmitted)">
                        {{'validation-message.Required'|translate |translateKey}}
                    </div>
                    <div class="alert-msg"
                        *ngIf="!statusForm.controls['notes'].valid && statusForm.controls['notes'].hasError('maxlength') && (statusForm.controls['notes'].touched || isSubmitted)">
                        {{'order.Length must be less than 2000' |translate | translateKey}}
                    </div>

                </div>
            </div>
            <div class="clearboth pull-right pad-r-8">
                <button class="btn blue-button"  [attr.disabled]="(statusForm.valid) && disableStatusButton ?null:''" tabindex="0"
                    type="submit">
                    {{'config-system.SUBMIT' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>

<!-- Change Member Preference Modal -->
<modal #changeMemberPreference>
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE MEMBER PREFERENCES' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div *ngIf="myMemberPreferences" class="modalcontent-section changeStatus">
            <div class="row" *ngFor="let preference of myMemberPreferences">
                <div class="col-md-6 mb-10">
                    <input tabindex="0" type="checkbox" [checked]="preference.selected"
                        (change)="OnCheckPreference(preference, $event.target.checked)">
                    <label for="{{'customer-service.' +preference.name |translate}}">
                        &nbsp;{{'customer-service.Privacy Requested' |translate }}
                    </label>
                </div>
            </div>
        </div>
        <div class="clearboth pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="button" (click)="updateMemberPreferences()">
                {{'config-system.SUBMIT' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>

<!-- Change Sponsor Modal -->
<modal #changeSponsor [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE SPONSOR' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="changeSponsorForm" [formGroup]="changeSponsorForm"
            (ngSubmit)="onSubmitSponsorChange(changeSponsorForm.valid)" class="col-xs-12 change-sponsor-form"
            novalidate>
            <div class="modalcontent-section">
                <div class="form-group col-xs-12 padding0">
                    <label *ngIf="isAgentAllowedToChangeSponsor && fboProfileDetail.memberStatus === statusActive "
                        class="padding0 col-xs-4"><input id="general" type="radio" [value]="0" class=""
                            name="sponsorType" formControlName="sponsorType">{{'customer-service.General Sponsor Change'| translate | translateKey}}</label>
                    <label class="padding0 col-xs-4 hide"><input id="fpcresponsorship" type="radio" class="" [value]="1"
                            name="sponsorType" formControlName="sponsorType">{{'customer-service.6 month FPC'| translate
                        |
                        translateKey}}</label>
                    <label class="padding0 col-xs-4 hide"><input id="fboresponsorship" type="radio" class="" [value]="2"
                            name="sponsorType" formControlName="sponsorType">{{'customer-service.12 month FBO'|
                        translate |
                        translateKey}}</label>
                </div>
                <div class="col-xs-12 padding0">
                    <div class="current-sponsor" *ngIf="sponsorDetails && sponsorDetails.length">
                        <div class="bold">
                            {{'customer-service.Current Sponsor Information' |translate |translateKey}}:
                        </div>
                        <ul class="ul slim-scroll sponsor-list padding0" slimScroll width="100%" size="3px"
                            height="inherit" alwaysVisible="false" wheelStep="20">
                            <li class="sponsor" *ngFor="let sponsor of sponsorDetails">
                                <ng-container *ngIf="sponsor.defaultSponsor">
                                    {{'customer-service.Home Country' |translate | translateKey}}:
                                </ng-container>
                                <span *ngIf="sponsor.storeCountryName">{{sponsor.storeCountryName + ': '}}</span>
                                <span *ngIf="sponsor.sponsorName">{{sponsor.sponsorName + ', '}}
                                </span>
                                <span *ngIf="sponsor.sponsorFBOID">
                                    {{sponsor.sponsorFBOID | distributorIdFormat}} </span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xs-12 col-sm-6 no-padding floating-input floatLabelContainer sponsor-id">
                        <input float-label type="text" id="newSponsorId" class="form-control"
                            placeholder="{{'order.Enter New Sponsor ID'|translate |translateKey}}"
                            formControlName="newSponsorId" mask="000-000-000-000" minlength="12"
                            (focus)="clearSponsorErrorMsg()">
                        <div class="alert-msg"
                            *ngIf="!changeSponsorForm.controls['newSponsorId'].valid && (changeSponsorForm.controls['newSponsorId'].touched || orderSubmitted || isSubmitted)">
                            <div *ngIf="changeSponsorForm.controls['newSponsorId'].hasError('required')">
                                {{'order.Sponsor ID is mandatory'|translate | translateKey}}
                            </div>
                            <div *ngIf="changeSponsorForm.controls['newSponsorId'].hasError('minlength')">
                                {{'validation-message.Enter valid FBO ID'|translate | translateKey}}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 no-padding" *ngIf="sponsorChangeSuccess">
                        <div class="success-msg">
                            <span>{{'customer-service.Sponsor updated successfully' |translate
                                |translateKey}}</span><span class="highlight"> {{ newSponsor.sponsorName }}</span>
                            <span class="highlight"> {{ newSponsor.sponsorId | distributorIdFormat}}</span>
                        </div>
                    </div>
                    <div class="col-xs-12 no-padding">
                        <div class="alert-msg" *ngIf="sponsorChangeError">
                            <span>{{'customer-service.Sponsor not updated' |translate |translateKey}}:</span>
                            <span class="highlight"> {{ changeSponsorForm.controls['newSponsorId'].value |
                                distributorIdFormat}}</span>
                        </div>
                        <div class="alert-msg" *ngIf="sponsorNotFoundError">
                            <span>{{'customer-service.Sponsor not found' |translate |translateKey}}:</span>
                            <span class="highlight"> {{ changeSponsorForm.controls['newSponsorId'].value |
                                distributorIdFormat}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearboth pull-right mt-20">
                <button class="btn blue-button" tabindex="0" type="submit"
                    [attr.disabled]="(changeSponsorForm.valid) ?null:''">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closeSponsorPopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>
<!-- Change Member Type and Level Modal -->
<modal #changeMemberTypeandLevel>
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE MEMBER TYPE / LEVEL / WHOLESALE QUALIFICATION' |translate
            |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo mt-5">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="changeMemberTypeandLevelForm" [formGroup]="changeMemberTypeandLevelForm"
            (ngSubmit)="saveMemberTypeorLevelInfo()" class="col-xs-12" novalidate>
            <div class="modalcontent-section membertypeandlevel">
                <div class="row">
                    <label class="col-sm-3 col-form-label" for="fbo">{{'customer-service.Member Type' |translate
                        |translateKey}} </label>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <select [attr.disabled]="true" class="form-control ng-pristine ng-invalid ng-touched"
                            formControlName="memberTypeModal" (change)="memberTypeChange()">
                            <option disabled value="">{{'order.Select Member Type' |translate |translateKey}}</option>
                            <option *ngFor="let memberType of memberTypeName" [value]="memberType.id">
                                {{memberType.type}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!changeMemberTypeandLevelForm.controls['memberTypeModal'].valid && (changeMemberTypeandLevelForm.controls['memberTypeModal'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-3 col-form-label" for="fbo">{{'customer-service.Member Level' |translate
                        |translateKey}} </label>
                    <div class="floating-input floatLabelContainer col-md-6">
                        <select [attr.disabled]="memberLevelDisable ? '':null"
                            class="form-control ng-pristine ng-invalid ng-touched" formControlName="memberLevel">
                            <option disabled value="">{{'order.Select Level' |translate |translateKey}}</option>
                            <option *ngFor="let Level of memberLevelList" [ngValue]="Level.id">{{Level.type}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!changeMemberTypeandLevelForm.controls['memberLevel'].valid && (changeMemberTypeandLevelForm.controls['memberLevel'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-3 col-form-label" for="enablewholesale">&nbsp;</label>
                    <div class="col-md-6 mb-10">
                        <div>
                            <input checked formControlName="enableStatus" tabindex="0" type="checkbox">
                            <label
                                for="{{'ticketing-system.Enable Wholesale Qualified Status' |translate |translateKey}}">
                                &nbsp;{{'ticketing-system.Enable Wholesale Qualified Status' |translate |translateKey}}
                            </label>
                        </div>
                        <div>
                            <input formControlName="triggerNotification" tabindex="0" type="checkbox">
                            <label
                                for="{{'ticketing-system.Trigger Opt-In Notification Bannet (My Account)' |translate |translateKey}}">
                                &nbsp; {{'ticketing-system.Opt-In' |translate |translateKey}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pull-right pad-r-8">
                <button [attr.disabled]="fboProfileDetail.wholesaleQualified ? '':null" class="btn blue-button"
                    tabindex="0" type="submit">
                    {{'config-system.UPDATE' |translate}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closeMemberlevelUpdatePopup()">
                    {{'config-system.CANCEL' |translate}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>
<!-- CC Limit Override Modal -->
<modal #overrideMonthlyCCLimit>
    <modal-header>
        <div class="color-blue">{{'customer-service.CC Limit Override' |translate |translateKey | uppercase}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="overrideMonthlyCCLimitForm" [formGroup]="overrideMonthlyCCLimitForm"
            (ngSubmit)="onSubmitCCLimitOverride(overrideMonthlyCCLimitForm.valid)" class="col-xs-12" novalidate>
            <div class="modalcontent-section overrideMonthlyCCLimit">
                <div class="row">
                    <div class="floating-input col-md-6">
                        <select class="form-control" formControlName="homeCountry" (change)="OnCountryChange()">
                            <option value="">{{'config-system.Country' |translate |translateKey}}</option>
                            <option *ngFor="let country of titanEnabledCountries" [ngValue]="country">{{country.name}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!overrideMonthlyCCLimitForm.controls['homeCountry'].valid && (overrideMonthlyCCLimitForm.controls['homeCountry'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Country is Mandatory' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="overrideMonthlyCCLimitForm.controls['homeCountry'].valid && errorCodes && errorCodes.length > 0">
                            <span *ngFor="let errors of errorCodes | findErrorCode:'country'">
                                {{errors.validationMessage}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-10">
                        <input id="applyOverride" formControlName="applyOverride" tabindex="0" type="checkbox"
                            (change)="OnCheckApplyCCOverride()">
                        <label for="{{'customer-service.Apply Override' |translate}}">
                            &nbsp;{{'customer-service.Apply Override' |translate |translateKey}}
                        </label>
                    </div>
                </div>
                <div class="row" *ngIf="showNewCCBlock">
                    <div class="col-md-6 mb-10 floating-input floatLabelContainer">
                        <input id="newCCLimit" class="form-control" formControlName="newCCLimit" float-label
                            tabindex="0" type="number"
                            placeholder="{{'customer-service.Enter New Limit Quantity'|translate | translateKey}}">
                        <div class="alert-msg" *ngIf="!overrideMonthlyCCLimitForm.controls['newCCLimit'].valid && overrideMonthlyCCLimitForm.controls['newCCLimit'].hasError('required')
                        && (overrideMonthlyCCLimitForm.controls['newCCLimit'].touched || isSubmitted)">
                            {{'validation-message.New Limit Quantity is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf="!overrideMonthlyCCLimitForm.controls['newCCLimit'].valid && overrideMonthlyCCLimitForm.controls['newCCLimit'].hasError('min')
                        && (overrideMonthlyCCLimitForm.controls['newCCLimit'].touched || isSubmitted)">
                            {{'validation-message.New Limit Quantity should be at least 1' |translate |translateKey}}
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showNewCCBlock">
                    <div class="floating-input floatLabelContainer col-md-6">
                        <input [owlDateTime]="dt5" class="form-control"
                            placeholder="{{'customer-service.End Date dd-mmm-yyyy'|translate | translateKey}}"
                            formControlName="endDate" appRestrictSpecialCharacters [min]="memberCCMinDate" tabindex="0"
                            maxlength="11" float-label DateFormat
                            (blur)="convertMemberCCDateFormat(overrideMonthlyCCLimitForm.controls['endDate'].value)">
                        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt5></owl-date-time>
                        <span class="" [owlDateTimeTrigger]="dt5">
                            <span class="fa fa-calendar calendar-icon-fbo select-pointer"></span>
                        </span>
                        <div class="alert-msg" *ngIf="!overrideMonthlyCCLimitForm.controls['endDate'].valid && overrideMonthlyCCLimitForm.controls['endDate'].hasError('required')
                        && (overrideMonthlyCCLimitForm.controls['endDate'].touched || isSubmitted)">
                            {{'validation-message.End Date is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!overrideMonthlyCCLimitForm.controls['endDate'].valid && overrideMonthlyCCLimitForm.controls['endDate'].hasError('lessThanOrEqualToCurrentDate') && !overrideMonthlyCCLimitForm.controls['endDate'].hasError('dateValidation')">
                            {{'order.End Date should be greater than Current date'|translate | translateKey}}
                        </div>
                        <!-- <div class="alert-msg" *ngIf="!overrideMonthlyCCLimitForm.controls['endDate'].valid && overrideMonthlyCCLimitForm.controls['endDate'].hasError('dateValidation')">
                            {{'validation-message.Enter valid Date'|translate | translateKey}}
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="pull-right pad-r-8">
                <button class="btn blue-button" tabindex="0" type="submit"
                    [disabled]="(!memberCCOverrideResponse && !overrideMonthlyCCLimitForm.controls['applyOverride'].value) || !overrideMonthlyCCLimitForm.valid
                 || !overrideMonthlyCCLimitForm.dirty || (memberCCOverrideResponse && !memberCCOverrideResponse.overrideFlag && (memberCCOverrideResponse.overrideFlag === overrideMonthlyCCLimitForm.controls['applyOverride'].value))">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>
<!-- Manage Government ID Modal -->
<modal #changeGovtID id="changeGovernmentID-popup" [closeOnEscape]="false" [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'MANAGE GOVERNMENT IDs'}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div *ngIf="duplicateGovIdErrorMessage" class="float-left alert-msg ml-5">
            <span>{{duplicateGovIdErrorMessage}}</span>
        </div>
        <div class="">
            <form *ngIf="updateGovIDForm" [formGroup]="updateGovIDForm"
                (ngSubmit)="addGovernmentIdsList(updateGovIDForm.value, updateGovIDForm.valid)">
                <div class="add-align mb-5"
                    *ngIf="updateGovIDForm.get('govermentIdentification').length < 10 && governmentIdManagePermission">
                    <a [routerLink]="" tabindex="0" (click)="addNewGovermentIdGroup()" *ngIf="updateGovIDForm">
                        <span class="glyphicon glyphicon-plus pad-r-3"></span>
                        {{'customer-service.Add New' |translate | translateKey}}
                    </a>
                </div>
                <div class="popup-height-align">
                    <div formArrayName="govermentIdentification"
                        *ngFor="let govermentIdentification of updateGovIDForm.get('govermentIdentification').controls; let i = index;">
                        <div [formGroupName]="i" class="row">
                            <div class="col-md-4 floating-input floatLabelContainer">
                                <select autofocus tabindex="0" formControlName="country" class="form-control"
                                    (change)="countryChangeForGovermentId($event.target.value,i, true)"
                                    [attr.disabled]="getCountryDisableStatus(govermentIdentification.value)">
                                    <option value="" [selected]="false">
                                        --{{'ticketing-system.Select' |translate | translateKey}}--
                                    </option>
                                    <option
                                        *ngFor="let country of memberAllowedCountries | orderBy:'countryName'"
                                        [value]="country.isoCodeThree">
                                        {{country.countryName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 floating-input floatLabelContainer align-margin-govtype ml-5">
                                <select autofocus tabindex="0" value="" duplicateIdentificationType
                                    (duplicateGovIdTypeFound)="duplicateGovIdType($event)" [formData]="updateGovIDForm"
                                    [index]="i" [attr.disabled]="getCountryDisableStatus(govermentIdentification.value)"
                                    (change)="setValidationsToGovernmentId(i,updateGovIDForm.controls['govermentIdentification'].controls[i].controls['country'].value,updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdType'].value)"
                                    formControlName="governmentIdType" class="form-control">
                                    <option value="" [selected]="false">--{{'ticketing-system.Select' |translate |
                                        translateKey}}--
                                    </option>
                                    <option
                                        *ngFor="let identification of governmentIdentificationTypes | identificationType:updateGovIDForm.controls['govermentIdentification'].controls[i].controls['country'].value:countries | orderBy:'identificationType'"
                                        [ngValue]="identification">{{identification.governmentIdTypeLabel ? identification.governmentIdTypeLabel : identification.identificationType}}
                                    </option>
                                </select>
                            </div>
                            <input type="hidden" formControlName="id">
                            <div
                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value && !(governmentIdValueEditIndexes.indexOf(updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value) > -1) ">
                                <div class="col-md-4 align-margin-govid mt-5">
                                    <div>
                                        {{updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].value
                                        | govIdMask
                                        :updateGovIDForm.controls['govermentIdentification'].controls[i].controls['country'].value
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngIf="!updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value || governmentIdValueEditIndexes.indexOf(updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value) > -1 ">
                                <div class="col-md-4 floating-input floatLabelContainer align-margin-govid">
                                    <input id="ssn-input" id="myInput" float-label type="text"
                                        formControlName="governmentIdValue" class="form-control"
                                        placeholder="{{'customer-service.Government ID' |translate |translateKey}}"
                                        (blur)="checkUniqueGovIDValue(updateGovIDForm,i)" [mask]="getGovIdMask(i)"
                                        [maxlength]="getGovIdMaxLength(i)" (input)="changeGovIdToUppercase(i)"
                                        (keydown)="changeGovIdToUppercase(i)" />
                                    <span>
                                        <div class="alert-msg"
                                            *ngIf="!updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].valid && updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].touched">
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('required')">
                                                {{'validation-message.Required'|translate |translateKey}}.
                                            </div>
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('pattern')">
                                                {{'validation-message.Please enter a valid ID'|translate
                                                |translateKey}}.
                                            </div>
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('minlength')">
                                                {{'validation-message.Minimum length should be '+
                                                updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].errors['minlength'].requiredLength+'
                                                characters'|translate |translateKey}}.
                                            </div>
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('maxlength')">
                                                {{'validation-message.Maximum length should be '+
                                                updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].errors['maxlength'].requiredLength
                                                +' characters'|translate |translateKey}}.
                                            </div>
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('duplicateGovId')">
                                                {{'validation-message.'+
                                                updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].errors['duplicateGovId']
                                                |translate |translateKey}}.
                                            </div>
                                            <div
                                                *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].hasError('inValidBsn')">
                                                {{'validation-message.'+
                                                updateGovIDForm.controls['govermentIdentification'].controls[i].controls['governmentIdValue'].errors['inValidBsn']
                                                |translate }}.
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="options" *ngIf="governmentIdManagePermission">
                                <i *ngIf="updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value && !(governmentIdValueEditIndexes.indexOf(updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value) > -1)"
                                    class="line-height1-2 fa fa-edit gov-edit-align float-left"
                                    (click)="editGovernmentID(i,updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value)"
                                    title="Edit"></i>
                                <i class="line-height1-2 fa fa-trash gov-delete-align float-right"
                                    (click)="deleteGovernmentID(i,updateGovIDForm.controls['govermentIdentification'].controls[i].controls['id'].value)"
                                    title="Delete"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pull-right pad-r-8">
                    <button class="btn blue-button" tabindex="0" type="submit" (mousedown)="updateButtonClicked()"
                        [disabled]="governmentIdValidationInProgress || !governmentIdManagePermission || !updateGovIDForm.dirty || updateGovIDForm.invalid">
                        {{'config-system.UPDATE' |translate |translateKey}}
                        <span *ngIf="governmentIdValidationInProgress">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closeGovtIDPopUp()"
                        (mousedown)="cancelButtonClicked()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<!-- Government ID remove confirmation popup starts -->
<modal #govIdRemoveConfirmation id="govIdRemoveConfirmation-popup" (onOpen)="deleteGovId = $event">
    <modal-header>
        <div class="color-blue">{{'customer-service.DELETE GOVERNMENT ID' |translate |translateKey | uppercase}}</div>
    </modal-header>
    <modal-content>
        <div class="">{{'customer-service.To DELETE the selected GovernmentID, please confirm by clicking DELETE below then complete the change by clicking UPDATE on the following page' |translate |translateKey}}</div>
        <div class="clearboth text-right mt-40">
            <button class="btn blue-button" tabindex="0" type="button"
                (click)="deleteGovernmentIDGroup(deleteGovId[0],deleteGovId[1])">
                {{'config-system.DELETE' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeDeleteGovernmentIDGroupPopup()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>
<!-- Government ID remove confirmation popup ends -->


<modal #changeBusinessEntity id="changeBusinessEntity-popup">
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE BUSINESS ENTITY' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="businessEntityForm" [formGroup]="businessEntityForm" (ngSubmit)="businessEnitiySubmit()"
            class="col-xs-12" novalidate>
            <div class="modalcontent-section changeBusinessEntity">
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="entityname-input" float-label type="text" formControlName="businessEntityName"
                            value="" class="form-control"
                            placeholder="{{'order.Business Entity Name' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityName'].valid && businessEntityForm.controls['businessEntityName'].hasError('required')&&(businessEntityForm.controls['businessEntityName'].touched || isSubmitted)">
                            {{'order.Business Entity Name is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'businessEntityName'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityName'].valid && businessEntityForm.controls['businessEntityName'].hasError('minlength')  && (businessEntityForm.controls['businessEntityName'].touched || isSubmitted)">
                            {{'order.Length must be greater than 3' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityName'].valid && businessEntityForm.controls['businessEntityName'].hasError('maxlength') &&  (businessEntityForm.controls['businessEntityName'].touched || isSubmitted)">
                            {{'order.Length must be less than 100' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="entityid-input" float-label type="text" formControlName="businessEntityId" value=""
                            class="form-control"
                            placeholder="{{'order.Business Entity ID' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityId'].valid && businessEntityForm.controls['businessEntityId'].hasError('required') && (businessEntityForm.controls['businessEntityId'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Business Entity ID is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityId'].valid && businessEntityForm.controls['businessEntityId'].hasError('minlength')  && (businessEntityForm.controls['businessEntityId'].touched || isSubmitted)">
                            {{'order.Length must be greater than 5' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityId'].valid && businessEntityForm.controls['businessEntityId'].hasError('maxlength') &&  (businessEntityForm.controls['businessEntityId'].touched || isSubmitted)">
                            {{'order.Length must be less than 50' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'businessEntityId'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityId'].valid && businessEntityForm.controls['businessEntityId'].hasError('alphaNumericValidation') &&  (businessEntityForm.controls['businessEntityId'].touched || isSubmitted)">
                            {{'order.Please enter valid Business Entity ID' |translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer"  *ngIf="personalInfoSettings.removeVatId">
                        <div  class="text-right vat_message">
                            <span>{{'order.IMPORTANT:  FBO Business VAT ID must be added to ‘Manage Government IDs’ section' |translate |translateKey}}</span>
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer"  *ngIf="!personalInfoSettings.removeVatId">
                            <input id="entityid-input" float-label type="text" formControlName="incomeTaxID" value=""
                            class="form-control"
                            placeholder="{{appConfig?.businessEntityConfig?.displayVATID ? ('order.VAT ID' |translate |translateKey) : ('order.Tax ID' |translate |translateKey)}}" />

                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['incomeTaxID'].valid &&businessEntityForm.controls['incomeTaxID'].hasError('required') && (businessEntityForm.controls['incomeTaxID'].touched || orderSubmitted || isSubmitted)">
                            <span *ngIf="appConfig?.businessEntityConfig?.displayVATID">{{'order.VAT ID is Mandatory'
                                |translate |translateKey}}</span>
                            <span *ngIf="!appConfig?.businessEntityConfig?.displayVATID">{{'order.Tax ID is Mandatory'
                                |translate |translateKey}}</span>
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'incomeTaxID'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['incomeTaxID'].valid && businessEntityForm.controls['incomeTaxID'].hasError('minlength') &&  (businessEntityForm.controls['incomeTaxID'].touched || isSubmitted)">
                            {{'order.Length must be greater than 1' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['incomeTaxID'].valid && businessEntityForm.controls['incomeTaxID'].hasError('maxlength') &&  (businessEntityForm.controls['incomeTaxID'].touched || isSubmitted)">
                            {{'order.Length must be less than 20' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['incomeTaxID'].valid && businessEntityForm.controls['incomeTaxID'].hasError('alphaNumericValidation') &&  (businessEntityForm.controls['incomeTaxID'].touched || isSubmitted)">
                            <span *ngIf="appConfig?.businessEntityConfig?.displayVATID">{{'order.Please enter valid VAT ID' |translate |translateKey}}</span>
                            <span *ngIf="!appConfig?.businessEntityConfig?.displayVATID">{{'order.Please enter valid Tax ID' |translate}}</span>
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <select class="form-control ng-pristine ng-invalid ng-touched"
                            formControlName="businessEntityIdType">
                            <option disabled default value="">{{'order.Business Entity Type' |translate |translateKey}}
                            </option>
                            <option [value]="113">Corporation (C)</option>
                            <option [value]="114">Ltd. Liability Corp (L)</option>
                            <option [value]="115">Other Bus. Entity (O)</option>
                            <option [value]="116">Trust (T)</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityIdType'].valid && (businessEntityForm.controls['businessEntityIdType'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Business Entity Type is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'businessEntityIdType'">{{errors.validationMessage}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="ressLine1-input" float-label type="text" formControlName="addressLine1" value=""
                            class="form-control" placeholder="{{'order.Address Line 1' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['addressLine1'].valid && businessEntityForm.controls['addressLine1'].hasError('required') && (businessEntityForm.controls['addressLine1'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Address Line 1 is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'addressLine1'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['addressLine1'].valid && businessEntityForm.controls['addressLine1'].hasError('minlength')  && (businessEntityForm.controls['addressLine1'].touched || isSubmitted)">
                            {{'order.Length must be greater than 3' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['addressLine1'].valid && businessEntityForm.controls['addressLine1'].hasError('maxlength') &&  (businessEntityForm.controls['addressLine1'].touched || isSubmitted)">
                            {{'order.Length must be less than 50' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="addressLine2-input" float-label type="text" formControlName="addressLine2" value=""
                            class="form-control" placeholder="{{'order.Address Line 2' |translate |translateKey}}" />
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'addressLine2'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['addressLine2'].valid && businessEntityForm.controls['addressLine2'].hasError('minlength')  && (businessEntityForm.controls['addressLine2'].touched || isSubmitted)">
                            {{'order.Length must be greater than 3' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['addressLine2'].valid && businessEntityForm.controls['addressLine2'].hasError('maxlength') &&  (businessEntityForm.controls['addressLine2'].touched || isSubmitted)">
                            {{'order.Length must be less than 50' |translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="city-input" float-label type="text" formControlName="city" value=""
                            class="form-control" placeholder="{{'order.City' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['city'].valid && businessEntityForm.controls['city'].hasError('required')&& (businessEntityForm.controls['city'].touched || orderSubmitted || isSubmitted)">
                            {{'order.City is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'city'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['city'].valid && businessEntityForm.controls['city'].hasError('minlength')  && (businessEntityForm.controls['city'].touched || isSubmitted)">
                            {{'order.Length must be greater than 2' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['city'].valid && businessEntityForm.controls['city'].hasError('maxlength') &&  (businessEntityForm.controls['city'].touched || isSubmitted)">
                            {{'order.Length must be less than 100' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer"
                        *ngIf="!appConfig?.businessEntityConfig?.hideStateCode">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="stateCodeId">
                            <option disabled value="">{{'order.State or Province' |translate |translateKey}}</option>
                            <option *ngFor="let state of statesModal" [ngValue]="state.id">{{state.stateName}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['stateCodeId'].valid && (businessEntityForm.controls['stateCodeId'].touched || orderSubmitted || isSubmitted)">
                            {{'order.State or Province is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'stateCodeId'">{{errors.validationMessage}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="floating-input col-md-6">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="countryCodeId"
                            (change)="onChangeOfBusinessEntityCountry()">
                            <option value="" disabled>{{'config-system.Country' |translate |translateKey}}</option>
                            <option *ngFor="let country of countriesList" [ngValue]="country.countryId">{{country.name}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['countryCodeId'].valid && (businessEntityForm.controls['countryCodeId'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Country is Mandatory' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="businessEntityForm.controls['countryCodeId'].valid && errorCodes && errorCodes.length > 0">
                            <span *ngFor="let errors of errorCodes | findErrorCode:'country'">
                                {{errors.validationMessage}}</span>
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="postalCode-input" float-label type="text" formControlName="postalCode" value=""
                            class="form-control" placeholder="{{'order.Zip Code' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['postalCode'].valid && businessEntityForm.controls['postalCode'].hasError('required')&&(businessEntityForm.controls['postalCode'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Zip Code is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'postalCode'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['postalCode'].valid && businessEntityForm.controls['postalCode'].hasError('minlength')  && (businessEntityForm.controls['postalCode'].touched || isSubmitted)">
                            {{'order.Length must be minimum 4' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['postalCode'].valid && businessEntityForm.controls['postalCode'].hasError('maxlength') &&  (businessEntityForm.controls['postalCode'].touched || isSubmitted)">
                            {{'order.Length must be less than 10' |translate}}
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer datepicker-disabled">
                        <input [owlDateTime]="dt4" class="form-control"
                            placeholder="{{'order.Start Date dd-mmm-yyyy'|translate | translateKey}}"
                            formControlName="startDate" [min]="minDate" [max]="dateNow" appRestrictSpecialCharacters
                            [tabindex]="-1"
                            maxlength="11" float-label DateFormat (isStartDate)="convertDateFormat($event)"
                            [isStartDateClicked]="true"
                            (blur)="businessEntityTransformDate(businessEntityForm.controls['startDate'].value,true)"
                            [readonly]="(fboProfileDetail.businessEntities && fboProfileDetail.businessEntities.length) ? true : false ">
                        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt4></owl-date-time>
                        <span class="" [owlDateTimeTrigger]="dt4">
                            <span class="fa fa-calendar calendar-icon-fbo select-pointer"></span>
                        </span>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['startDate'].valid && businessEntityForm.controls['startDate'].hasError('dateValidation') && (businessEntityForm.controls['startDate'].touched)">
                            {{'order.Enter valid Date'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['startDate'].valid && businessEntityForm.controls['startDate'].hasError('inValidStartDate') && (businessEntityForm.controls['startDate'].touched)">
                            {{'order.Start Date should be in Current Month'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['startDate'].valid && businessEntityForm.controls['startDate'].hasError('startDateValidation') && (businessEntityForm.controls['startDate'].touched)">
                            {{'order.Greater than End Date'|translate | translateKey}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input [owlDateTime]="dt6" class="form-control"
                            placeholder="{{'order.End Date dd-mmm-yyyy'|translate | translateKey}}"
                            formControlName="endDate" appRestrictSpecialCharacters maxlength="11" float-label DateFormat
                            (blur)="businessEntityTransformDate(businessEntityForm.controls['endDate'].value,false)">
                        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt6></owl-date-time>
                        <span class="" [owlDateTimeTrigger]="dt6">
                            <span class="fa fa-calendar calendar-icon-fbo select-pointer"></span>
                        </span>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['endDate'].valid && businessEntityForm.controls['endDate'].hasError('dateValidation') && (businessEntityForm.controls['endDate'].touched)">
                            {{'validation-message.Enter valid Date'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['endDate'].valid && businessEntityForm.controls['endDate'].hasError('EndDateValidation')">
                            {{'validation-message.Less than Start Date'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="status">
                            <option disabled value="">{{'order.Status' |translate |translateKey}}</option>
                            <option [value]="1">Active</option>
                            <option [value]="2">Inactive</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['status'].valid && (businessEntityForm.controls['status'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Status is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'status'">{{errors.validationMessage}}</span>
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer"
                        *ngIf="appConfig?.businessEntityConfig?.showVatPayer">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="vatPayer">
                            <option disabled default value="">{{'order.Vat Payer' |translate |translateKey}} </option>
                            <option [value]="vatPayerOption.Y">Yes</option>
                            <option [value]="vatPayerOption.N">No</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!businessEntityForm.controls['businessEntityIdType'].valid && (businessEntityForm.controls['businessEntityIdType'].touched || orderSubmitted || isSubmitted)">
                            {{'order.Business Entity Type is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'businessEntityIdType'">{{errors.validationMessage}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-md-6 alert-msg"
                    *ngIf="businessEntityForm.valid && fboBusinessEntity.invalidStatusUpdate">
                    {{'order.Business Entity update restricted since the status is in Inactive'|translate
                    |translateKey}}
                </div> -->
                <div class="pull-right pad-r-8">
                    <button class="btn blue-button" tabindex="0" type="submit"
                    [disabled]="businessEntityForm.invalid ||!businessEntityForm.dirty ||disableBusinessEntityButton">
                        {{'config-system.UPDATE' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforBusinessEntity()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </div>
        </form>
    </modal-content>
</modal>


<modal #changeDOB>
    <modal-header>
        <div class="color-blue">{{'customer-service.Change DOB'| uppercase |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <form *ngIf="changeDOBForm" [formGroup]="changeDOBForm" (ngSubmit)="updateDateOfBirth(changeDOBForm.valid)"
            class="col-xs-12" novalidate>
            <div class="modalcontent-section changeDOB">
                <div class="row">
                    <div class=" col-md-6 floating-input floatLabelContainer">
                        <input id="birthDate" [owlDateTime]="dt3" class="form-control"
                            placeholder="{{'customer-service.DOB Placeholder'|translate | translateKey}}"
                            formControlName="birthDate" appRestrictSpecialCharacters tabindex="0" maxlength="11"
                            float-label DateFormat
                            (blur)="birthdatetransformDate(changeDOBForm.controls['birthDate'].value)">
                        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt3></owl-date-time>
                        <span class="" [owlDateTimeTrigger]="dt3">
                            <span class="fa fa-calendar calendar-icon-fbo select-pointer"></span>
                        </span>
                        <div class="alert-msg" *ngIf="!changeDOBForm.controls['birthDate'].valid && changeDOBForm.controls['birthDate'].hasError('Required')
                        && (changeDOBForm.controls['birthDate'].touched || isSubmitted)">
                            {{'customer-service.DOB Required' |translate |translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!changeDOBForm.controls['birthDate'].valid && changeDOBForm.controls['birthDate'].hasError('dateValidation')">
                            {{'customer-service.DOB Valid Date'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!changeDOBForm.controls['birthDate'].valid && changeDOBForm.controls['birthDate'].hasError('eighteenYearsValidation')">
                            {{'customer-service.DOB Age Validation'|translate | translateKey}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="pull-right pad-r-8">
                <button class="btn blue-button" tabindex="0" type="submit"
                    [attr.disabled]="(changeDOBForm.valid) ?null:''">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>

<modal #bonusInformationModal id="bonusInformation-popup" *ngIf="!showSingleAndDirectDebitMenu" [closeOnEscape]="false"
    [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'BONUS INFORMATION'}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>

        <div class="">
            <div class="add-align bouns mb-5 mt-5">
                <a [routerLink]="" tabindex="0" (click)="addNewBonusInformation(fboProfileDetail.memberId)"
                    *ngIf="hasFboBonusInfoManagePermission && ((memberBonusInfo && !memberBonusInfo.accountNumber) || !memberBonusInfo) && !editBonusInfo">
                    <span class="glyphicon glyphicon-plus pad-r-3"></span>
                    {{'customer-service.Add New' |translate | translateKey}}
                </a>
            </div>
            <div class="row">
                <div class="col-lg-10">
                    <div
                        *ngIf="personalInfoSettings && personalInfoSettings.enableSingleAndDirectDebit ;else bonusInfoNotApplicable">
                        <div class="popup-height-align">
                            <div class="my-6">
                                <app-bonus-info-form *ngIf="(memberBonusInfo && memberBonusInfo.accountNumber) || editBonusInfo"
                                    (bonusInfoSubmit)="getBonusInfo($event)" [bonusInfoSchemaUrl]="bonusInfoSchemaUrl"
                                    [preloadBonusInformation]="preloadMemberBonusInfo"
                                    (bonusInfoSubmitOnInputChange)="getBonusInfoOnInputChange($event)">
                                </app-bonus-info-form>
                                <div *ngIf="isDeleteBonusInfo">
                                    {{"Bonus information will delete on clicking UPDATE"}}.
                                </div>
                            </div>
                            <div *ngIf="!editBonusInfo && (((memberBonusInfo && !memberBonusInfo.accountNumber) || !memberBonusInfo))">
                                <div *ngIf="hasFboBonusInfoManagePermission else noBonusInfo">
                                    {{"Add new bonus information"}}.
                                </div>
                                <ng-template #noBonusInfo>
                                    {{"Bonus information not added"}}.
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #bonusInfoNotApplicable>
                        {{"Bonus information not applicable for -"}} {{homeCountry}}.
                    </ng-template>
                </div>
                <div class="col-lg-2">
                    <div class="options pull-right"
                        *ngIf="hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission">
                        <span
                            *ngIf="hasFboBonusInfoManagePermission && !editBonusInfo && (memberBonusInfo && memberBonusInfo.accountNumber) && !isDeleteBonusInfo">
                            <i class="line-height1-2 fa fa-edit gov-edit-align pull-left" (click)="editBonusInformation(fboProfileDetail.memberId,memberBonusInfo && memberBonusInfo.id ?
                                    memberBonusInfo.id : null)" title="Edit"></i>
                        </span>
                        <span
                            *ngIf="(hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission) && (memberBonusInfo && memberBonusInfo.accountNumber) && !isDeleteBonusInfo">
                            <i class="line-height1-2 fa fa-trash gov-delete-align "
                                (click)="deleteBonusInfoConfirmation(false)" title="Delete"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="pull-right pad-r-8">
                <button class="btn blue-button" tabindex="0"
                    [disabled]=" (isDeleteBonusInfo || editBonusInfo )&& disableBonusButton ? false : true" (click)="updateBonusInformation()"
                    type="submit" *ngIf="hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closeBonusInformationModal()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </div>
    </modal-content>
</modal>

<!--BLX Bonus Information Modal start-->

<modal #blxBonusInformationModal id="blxBonusInformation-popup" *ngIf="showSingleAndDirectDebitMenu" [closeOnEscape]="false"
    [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'Bonus/Debit Information'}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>

        <div class="">
            <div class="add-align mb-5 mt-5">
                <a [routerLink]="" tabindex="0" (click)="addNewBonusInformation(fboProfileDetail.memberId)"
                    *ngIf="hasFboBonusInfoManagePermission && (((memberBonusInfo && !memberBonusInfo.accountNumber) || !memberBonusInfo)) && !editBonusInfo">
                    <span class="glyphicon glyphicon-plus pad-r-3"></span>
                    {{'customer-service.Add New' |translate | translateKey}}
                </a>
            </div>
            <div class="row">
                <div class="col-lg-10">
                    <div
                        *ngIf="personalInfoSettings && personalInfoSettings.enableSingleAndDirectDebit ;else bonusInfoNotApplicable">
                        <div class="popup-height-align">
                            <div class="my-6">
                                <app-bonus-info-form *ngIf="(memberBonusInfo && memberBonusInfo.accountNumber) || editBonusInfo"
                                    (bonusInfoSubmit)="getBonusInfo($event)" [bonusInfoSchemaUrl]="bonusInfoSchemaUrl"
                                    [preloadBonusInformation]="preloadMemberBonusInfo"
                                    (bonusInfoSubmitOnInputChange)="getBonusInfoOnInputChange($event)">
                                </app-bonus-info-form>
                                <div class="blxSchemaFormSection blxCheckboxSection"
                                    *ngIf="(memberBonusInfo && memberBonusInfo.accountNumber) || editBonusInfo">
                                    <div *ngIf="bonusInfoAgreements && bonusInfoAgreements.length > 0">
                                        <div class="col-12 form-check px-0 my-2"
                                            *ngFor="let agreement of bonusInfoAgreements;let i = index;">
                                            <label tabindex="0" class="check-lbl form-check-box font-16">
                                                <input role="checkbox" type="checkbox" aria-label=""
                                                    (change)="selectedAgreements(agreement)"
                                                    [disabled]="disableBonusInfoChecks" class="check-box" name=""
                                                    value="true" id="" [checked]="agreement.isSelected">
                                                <span class="label-text"></span>
                                                <span class="form-check-text">{{'I have read and agreed to the' }}
                                                    <span class=""
                                                        *ngIf="!(agreement?.documentUrl)">{{agreement?.displayName}}</span>
                                                    <span (click)="$event?.stopPropagation();"
                                                        *ngIf="agreement?.documentUrl">
                                                        <a class="link--light align-top d-inline-block" target="_blank"
                                                            [href]="agreement?.documentUrl">{{agreement?.displayName}}</a>
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div *ngIf="displayIBANAckError">
                                        <span class="text-red">
                                            {{ 'You must agree to terms and conditions before proceeding'}}
                                        </span>
                                    </div>

                                </div>
                                <div *ngIf="isDeleteBonusInfo" class="delete-confirmation">
                                    {{"Bonus information will delete on clicking UPDATE"}}.
                                </div>
                            </div>
                            <div *ngIf="!editBonusInfo && (((memberBonusInfo && !memberBonusInfo.accountNumber) || !memberBonusInfo))">
                                <div *ngIf="hasFboBonusInfoManagePermission else noBonusInfo">
                                    {{"Add new bonus information"}}.
                                </div>
                                <ng-template #noBonusInfo>
                                    {{"Bonus information not added"}}.
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #bonusInfoNotApplicable>
                        {{"Bonus information not applicable for -"}} {{homeCountry}}.
                    </ng-template>
                </div>
                <div class="col-lg-2">
                    <div class="options pull-right"
                        *ngIf="hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission">
                        <span
                            *ngIf="hasFboBonusInfoManagePermission && !editBonusInfo && (memberBonusInfo && memberBonusInfo.accountNumber) && !isDeleteBonusInfo">
                            <i class="line-height1-2 fa fa-edit gov-edit-align pull-left" (click)="editBonusInformation(fboProfileDetail.memberId,memberBonusInfo && memberBonusInfo.id ?
                                    memberBonusInfo.id : null)" title="Edit"></i>
                        </span>
                        <span
                            *ngIf="(hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission) && (memberBonusInfo && memberBonusInfo.accountNumber) && !isDeleteBonusInfo">
                            <i class="line-height1-2 fa fa-trash gov-delete-align "
                                (click)="deleteBonusInfoConfirmation(false)" title="Delete"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="pull-right pad-r-8">
                <button class="btn blue-button" tabindex="0"
                    [disabled]=" (isDeleteBonusInfo || (editBonusInfo && !invalidIban)) ? false : true"
                    (click)="updateBonusInformation(isBonusInfo)" type="submit"
                    *ngIf="hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closeBonusInformationModal()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </div>
    </modal-content>
</modal>
<!--BLX Bonus Information Modal end-->


<!-- Single and direct debit payment methods modal start -->
<modal #singleAndDirectDebitPaymentModal id="single-and-direct-debit-payment-popup" *ngIf="showSingleAndDirectDebitMenu"
    [closeOnEscape]="false" [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'Single/Direct Debit'}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="row mar-top-20 pad-t-10">
            <div class="col-lg-10">
                <div *ngIf="personalInfoSettings && personalInfoSettings.enableSingleAndDirectDebit">
                    <div class="popup-height-align">
                        <div class="my-6">
                            <div class="blxPaymentCheckbox" *ngIf="personalInfoSettings.enableCreditAssessment">
                                <input tabindex="0" type="checkbox" (change)="onCreditAssessmentChange($event)"
                                    [checked]="isCreditAssessmentEnabled" [disabled]="!memberBonusInfo || creditAssessmentApproved || (memberBonusInfo && !memberBonusInfo.accountNumber)"
                                    >
                                <label>
                                    &nbsp;{{ 'Credit Assessment completed by Customer Care' }}
                                </label>
                            </div>
                            <br>
                            <div class="blxPaymentCheckbox">
                                <input tabindex="0" type="checkbox" (change)="onDirectDebitChange($event)"
                                    [checked]="isDirectDebitEnabled"
                                    [disabled]="!singleAndDirectDebitManagePermission || (!isCreditAssessmentEnabled && personalInfoSettings && personalInfoSettings.enableCreditAssessment)  || !memberBonusInfo || (((memberBonusInfo && !memberBonusInfo.accountNumber) || !memberBonusInfo))">
                                <label>
                                    &nbsp;{{ 'Enable Direct Debit as payment option' }}
                                </label>
                            </div>
                            <br>
                            <div class="blxPaymentCheckbox">
                                <input tabindex="0" type="checkbox" (change)="onSingleDebitChange($event)"
                                    [disabled]="!singleAndDirectDebitManagePermission || (!isCreditAssessmentEnabled && personalInfoSettings && personalInfoSettings.enableCreditAssessment)" [checked]="isSingleDebitEnabled">
                                <label>
                                    &nbsp;{{ 'Enable Single Debit as payment option' }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pull-right pad-r-8">
                <button class="btn blue-button" tabindex="0" (click)="updateBonusInformation()" type="submit"
                    *ngIf="singleAndDirectDebitManagePermission">
                    {{'config-system.UPDATE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closeSingleAndDirectDebitModal()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
        </div>
    </modal-content>
</modal>
<!-- Single and direct debit payment methods modal end -->

<modal #deleteBonusInfoConfirmationPopup id="govIdRemoveConfirmation-popup">
    <modal-header>
        <div class="color-blue">{{'BONUS INFORMATION'}}</div>
    </modal-header>
    <modal-content>
        <div class="">{{'To DELETE the selected Bonus Information, please confirm by clicking DELETE below then complete the change by clicking UPDATE on the following page' }}</div>
        <div class="clearboth text-right mt-40">
            <button class="btn blue-button" tabindex="0" type="button" (click)="deleteBonusInfoConfirmation(true)">
                {{'config-system.DELETE' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeDeleteBonusInfoConfirmation()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>

<modal #accountNotificationChange>
    <modal-header>
        <div class="color-blue">{{'customer-service.ACCOUNT NOTIFICATION' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail?.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="accountNotification modalcontent-section">
            <form *ngIf="accountNotificationForm" [formGroup]="accountNotificationForm" id="accountNotification-form">
                <div class="col-md-12 floating-input floatLabelContainer mt-20">
                    <input id="subject-input" float-label type="text" formControlName="subject" value=""
                        class="form-control" placeholder="{{'customer-service.Subject' |translate |translateKey}}" />
                    <div class="alert-msg"
                        *ngIf="!accountNotificationForm.controls['subject'].valid && accountNotificationForm.controls['subject'].hasError('required')&&(accountNotificationForm.controls['subject'].touched || isSubmitted)">
                        {{'customer-service.Subject is Mandatory' |translate |translateKey}}
                    </div>
                    <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                        <span
                            *ngFor="let errors of errorCodes | findErrorCode:'subject'">{{errors.validationMessage}}</span>
                    </div>
                </div>
                <div class="col-md-12 floating-input floatLabelContainer textarea-msg">
                    <textarea id="bodyInput" float-label class="form-control overflow-x-hidden" formControlName="body"
                        placeholder="{{'customer-service.Body'|translate}}" rows="5"></textarea>
                </div>
                <div class="col-md-12">
                    <input id="enableNotification" name="enableNotification"
                        [attr.disabled]="(accountNotification)?null:''" formControlName="enable" tabindex="0"
                        type="checkbox" (change)="enableAccountNotificationChange($event)">
                    <label class="notificationLabel">{{'customer-service.Enable' |translate |translateKey}}</label>
                </div>
                <div class="pull-right pad-r-8">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [attr.disabled]="(accountNotificationForm.valid) ?null:''"
                        (click)="accountNotificationSubmit()">
                        {{'config-system.UPDATE' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button"
                        (click)="closePopUpforAccountNotificationChange()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<modal #updateMemberName>
    <modal-header>
        <div class="color-blue">{{'customer-service.Update Name'| uppercase |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="accountNotification modalcontent-section">
            <form *ngIf="changeMemberNameForm" [formGroup]="changeMemberNameForm" id="name-form"
                (ngSubmit)="onSubmitMemberName(changeMemberNameForm.valid)">
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="firstName-input" float-label type="text" formControlName="firstName"
                            (blur)="onMemberNameChange()" class="form-control"
                            [maxlength]="(personalInfoFormValidations?.firstName?.maxLength)"
                            placeholder="{{'customer-service.First Name' |translate |translateKey}}" />

                        <div class="alert-msg"
                            *ngIf="!changeMemberNameForm.controls['firstName'].valid && changeMemberNameForm.controls['firstName'].touched">


                            <div *ngIf="changeMemberNameForm.controls['firstName'].errors.required">
                                {{'customer-service.First Name is Mandatory' |translate |translateKey}}
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['firstName'].errors.maxlength">
                                {{'Max Length should be 20'|translate |translateKey}}
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['firstName'].errors.noEmptyString">
                                {{'validation-message.Should not contain a whitespace'|translate |translateKey}}.
                            </div>
                            <div
                                *ngIf="!changeMemberNameForm.controls['firstName'].errors.noEmptyString && changeMemberNameForm.controls['firstName'].errors.alphaNumericValidation">
                                {{'validation-message.Only alpha numeric characters are allowed'|translate
                                |translateKey}}.
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="middleName-input" float-label type="text" formControlName="middleName"
                            (blur)="onMemberNameChange()" class="form-control"
                            [maxlength]="(personalInfoFormValidations?.middleName?.maxLength)"
                            placeholder="{{'customer-service.Middle Name' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!changeMemberNameForm.controls['middleName'].valid && changeMemberNameForm.controls['middleName'].touched">

                            <div *ngIf="changeMemberNameForm.controls['middleName'].errors.noEmptyString">
                                {{'validation-message.Should not contain a whitespace'|translate |translateKey}}.
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['middleName'].errors.required">
                                {{'customer-service.Middle Name is Mandatory' |translate |translateKey}}
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['middleName'].errors.maxlength" >
                                {{'Max Length should be 24'|translate |translateKey}}
                            </div>
                            <div
                                *ngIf="!changeMemberNameForm.controls['middleName'].errors.noEmptyString && changeMemberNameForm.controls['middleName'].errors.alphaNumericValidation">
                                {{'validation-message.Only alpha numeric characters are allowed'|translate
                                |translateKey}}.
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="lastName-input" float-label type="text" formControlName="lastName"
                            (blur)="onMemberNameChange()" class="form-control"
                            [maxlength]="(personalInfoFormValidations?.lastName?.maxLength)"
                            placeholder="{{'customer-service.Last Name' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!changeMemberNameForm.controls['lastName'].valid && changeMemberNameForm.controls['lastName'].touched">


                            <div *ngIf="changeMemberNameForm.controls['lastName'].errors.required">
                                {{'customer-service.Last Name is Mandatory' |translate |translateKey}}
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['lastName'].errors.maxlength">
                                {{'Max Length should be 20'|translate |translateKey}}
                            </div>
                            <div *ngIf="changeMemberNameForm.controls['lastName'].errors.noEmptyString">
                                {{'validation-message.Should not contain a whitespace'|translate |translateKey}}.
                            </div>
                            <div
                                *ngIf="!changeMemberNameForm.controls['lastName'].errors.noEmptyString && changeMemberNameForm.controls['lastName'].errors.alphaNumericValidation">
                                {{'validation-message.Only alpha numeric characters are allowed'|translate
                                |translateKey}}.
                            </div>

                        </div>
                    </div>
                </div>

                <div class="pull-right pad-r-8 mt-20">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [disabled]="!changeMemberNameForm.valid  || nameUpdate || !changeMemberNameForm.dirty ||disableNameButton">
                        {{'config-system.UPDATE' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforNameChange()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<modal #updateEmail>
    <modal-header>
        <div class="color-blue">{{'customer-service.UPDATE EMAIL ADDRESS' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="accountNotification modalcontent-section">
            <form *ngIf="emailForm" [formGroup]="emailForm" id="email-form">
                <div class="col-md-12 mt-20">
                    <span class="col-md-3 fw-600">{{'customer-service.Current Email' |translate | translateKey}}</span>
                    <div class="col-md-6 word-break--overflow">
                        <span *ngIf="fboProfileDetail.emailId">{{fboProfileDetail.emailId | lowercase}}</span>
                        <span *ngIf="!fboProfileDetail.emailId">{{'customer-service.No Email' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <span class="col-md-3 fw-600 mt-7">{{'customer-service.New Email' |translate | translateKey}}</span>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="newEmail-input" float-label type="text" formControlName="email" value=""
                            (input)="emailCheck()" class="form-control"
                            placeholder="{{'customer-service.New Email' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!emailForm.controls['email'].valid && emailForm.controls['email'].hasError('required')&&(emailForm.controls['email'].touched || isSubmitted)">
                            {{'customer-service.New Email is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'subject'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!emailForm.controls['email'].valid && emailForm.controls['email'].hasError('emailValidationRule') && !emailForm.controls['email'].hasError('required') &&(emailForm.controls['email'].touched|| isSubmitted)">
                            {{'customer-service.Enter valid Email'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <span class="col-md-3 fw-600 mt-7">{{'customer-service.Confirm Email' |translate |
                        translateKey}}</span>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="confirmEmail-input" float-label type="text" formControlName="confirmEmail" value=""
                            (input)="emailCheck()" class="form-control"
                            placeholder="{{'customer-service.Confirm Email' |translate |translateKey}}" />
                        <div class="alert-msg"
                            *ngIf="!emailForm.controls['confirmEmail'].valid && emailForm.controls['confirmEmail'].hasError('required')&&(emailForm.controls['confirmEmail'].touched || isSubmitted)">
                            {{'customer-service.Confirm Email is Mandatory' |translate |translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf=" errorCodes && errorCodes.length > 0">
                            <span
                                *ngFor="let errors of errorCodes | findErrorCode:'subject'">{{errors.validationMessage}}</span>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!emailForm.controls['confirmEmail'].valid && emailForm.controls['confirmEmail'].hasError('emailValidationRule') && !emailForm.controls['confirmEmail'].hasError('required') &&(emailForm.controls['confirmEmail'].touched|| isSubmitted)">
                            {{'customer-service.Enter valid Email'|translate | translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf="emailForm.valid && emailMismatch">
                            {{'customer-service.New Email And Confirm Email must be same'|translate | translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf="emailForm.valid && !emailMismatch && !isNewEmail">
                            {{'customer-service.New Email must not be same as previous Email'|translate | translateKey}}
                        </div>
                        <div class="alert-msg" *ngIf="errorCodes && errorCodes.length > 0">
                            {{'customer-service.Email Already Exists'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <div class="pull-right pad-r-8 mt-20">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [attr.disabled]="(emailForm.valid && !emailMismatch && isNewEmail && disableEmailButton) ?null:''"
                        (click)="changeEmailSubmit()">
                        {{'config-system.UPDATE' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforEmailChange()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>

<!-- Update Phone Number start -->
<modal #updatePhoneNumber>
    <modal-header>
        <div class="color-blue">{{'customer-service.Update Phone Number' |translate | translateKey | uppercase}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="accountNotification modalcontent-section">
            <form *ngIf="updatePhoneNumberForm && showUpdatePhoneModal" [formGroup]="updatePhoneNumberForm"
                id="email-form" (ngSubmit)="onSubmitPhoneNumber(updatePhoneNumberForm.valid)">
                <div class="col-md-12 my-35">
                    <div class="col-md-3 form-group floatLabelContainer">
                        <select id="phoneType" formControlName="phoneType" float-label [addLabel]="false"
                            attr.aria-label="{{'customer-service.Type' | translate | translateKey}}" tabindex="0"
                            autocomplete="Type" aria-required="true" class="form-control"
                            (change)="onChangePhoneType($event.target.value)">
                            <option *ngFor="let contactType of contactTypes" [value]='contactType.value'>
                                {{contactType.name }}</option>
                        </select>
                        <label id="label-class" for="phoneType">{{'customer-service.Type' | translate | translateKey
                            }}</label>
                    </div>
                    <div class="col-md-6 form-group floatLabelContainer">
                        <input id="phoneNumber" float-label [addLabel]="false" role="textbox"
                            attr.aria-label="{{'customer-service.Phone Number' | translate | translateKey}}"
                            tabindex="0" autocomplete="PhoneNumber" aria-required="true" class="form-control"
                            placeholder="{{'customer-service.Phone Number' | translate | translateKey }}*"
                            formControlName="phoneNumber" [mask]="phoneNumberFormat || '' " type="tel">
                        <label id="label-class" for="phoneNumber">{{'customer-service.Phone Number' | translate |
                            translateKey }}*</label>
                        <span tabindex="0" class="alert-msg" *ngIf="!updatePhoneNumberForm.controls['phoneNumber'].valid
                                        &&updatePhoneNumberForm.controls['phoneNumber'].hasError('required')
                                        && (updatePhoneNumberForm.controls['phoneNumber'].touched)">
                            {{'common.Required' | translate | translateKey}}
                        </span>
                        <span tabindex="0" class="alert-msg" *ngIf="!updatePhoneNumberForm.controls['phoneNumber'].valid
                        &&updatePhoneNumberForm.controls['phoneNumber'].hasError('minlength')
                        && (updatePhoneNumberForm.controls['phoneNumber'].touched)">
                        {{'common.Minimum length should be ' +updatePhoneNumberForm.controls['phoneNumber'].errors['minlength'].requiredLength
                        +' characters.' | translate | translateKey}}                        </span>
                        <span tabindex="0" class="alert-msg" *ngIf="!updatePhoneNumberForm.controls['phoneNumber'].valid
                        &&updatePhoneNumberForm.controls['phoneNumber'].hasError('maxlength')
                        && (updatePhoneNumberForm.controls['phoneNumber'].touched)">
                            {{'common.Maximum length should be ' +
                            updatePhoneNumberForm.controls['phoneNumber'].errors['maxlength'].requiredLength
                            +' characters.' | translate | translateKey}}
                        </span>
                    </div>
                    <div class="alert-msg" *ngIf="errorCodes && errorCodes.length > 0">
                        <span
                            *ngFor="let errors of errorCodes | findErrorCode:'subject'">{{errors.validationMessage}}</span>
                    </div>
                </div>
                <div class="pull-right pad-r-8 mt-20">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [disabled]="!updatePhoneNumberForm.valid || !updatePhoneNumberForm.dirty">
                        {{'config-system.UPDATE' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closePhoneNumberPopup()">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<!-- Update Phone Number end -->
<!-- show more information in impersonate failure case start-->
<modal #showMoreInformation>
    <modal-content>
        <div>
            <div>
                <span class="text-left">
                    <p class="titte-font bold">{{'customer-service.Impersonate login procedure description' | translate
                        | translateKey}}</p>
                    <p class="titte-font15 bold">
                        <span>{{'customer-service.Visit' | translate | translateKey }}</span>
                        <span><a href="{{corporateSiteUrl}}" target="_blank"
                                rel="noopener noreferrer">{{corporateSiteName}}</a></span>
                        <span>{{'customer-service.and select the respective market and language' | translate |
                            translateKey }}</span>
                    </p>
                    <ol>
                        <li>{{'customer-service.Select “Login” in the top right corner of the website' | translate |
                            translateKey}}</li>
                        <li>{{'customer-service.Select “Need help logging in?” located directly below the fields and
                            button to log in with' | translate | translateKey}}</li>
                        <li>{{'customer-service.In the field for Login ID, enter the email address associated with the
                            account and select the “Submit” button which will trigger an email to reset the account
                            password' | translate | translateKey}}</li>
                        <li>{{'customer-service.Once the email is received, select/click on the hyperlink within this
                            email to be directed to a webpage where you will be able to establish a new password' |
                            translate | translateKey}}</li>
                        <li>{{'customer-service.Establish and confirm the new password' | translate | translateKey}}
                        </li>
                        <li>
                            <span>{{'customer-service.Log in to' | translate | translateKey}}</span>
                            <span><a href="{{corporateSiteUrl}}" target="_blank"
                                    rel="noopener noreferrer">{{corporateSiteName}}</a></span>
                            <span>{{'customer-service.with the newly established password' | translate |
                                translateKey}}</span>
                        </li>
                    </ol>
                </span>
            </div>
        </div>
        <div class="pull-right pad-r-8 mt-20">
            <button class="btn blue-button" tabindex="0" type="submit" (click)="closeShowMoreInformationPopup()">
                {{'config-system.OK' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeShowMoreInformationPopup()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>
<!-- show more information in impersonate failure case end-->
<!-- modal for ach payment -->
<modal #achPaymentPopup [closeOnEscape]="false" [closeOnOutsideClick]="true" (onClose)="onPaymentAchFormClose()"
    class="ach-modal">
    <modal-header>
        <!-- <div class="color-blue">{{'order.Create Echeck Payment Form' |translate | translateKey}}</div> -->
        <h4 class="color-blue" *ngIf="!isEditEcheck">{{'customer-service.Create Pay by Check Account' |translate }}</h4>
        <h4 class="color-blue" *ngIf="isEditEcheck">{{'customer-service.Edit Pay by Check Account' |translate }}</h4>
        <!-- <span  class="pull-right pointer" (click)="onPaymentAchFormClose()">X</span> -->
    </modal-header>
    <modal-content *ngIf="fboProfileDetail">
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="pay-by-check">
            <app-payment-echeck *ngIf="addNewAchCard" [fboProfileDetail]="fboProfileDetail"
                [editEcheckInfo]="editEcheckInfo" (closeAchPaymentPopup)="closeAchPaymentPopup($event)"
                [achPaymentPopup]="achPaymentPopup"></app-payment-echeck>
        </div>

    </modal-content>
    <modal-footer>

    </modal-footer>
</modal>

<!-- Update PC Sponsor Eligible Status Modal -->
<modal #updatePCSponsorStatus>
    <modal-header>
        <div class="color-blue">{{'customer-service.PC Sponsorship Eligibility' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
            <div class="modalcontent-section changeStatus">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6 floating-input">
                        <select [(ngModel)]="selectedStatus" class="ng-pristine ng-invalid ng-touched" (ngModelChange)="onPCSponsorValueChange($event)" style="width: inherit;">
                            <option [selected]="pcSponsorEligibleStatus" *ngFor="let pcSponsorStatus of PCSponsorshipStatus" value="{{pcSponsorStatus}}">{{pcSponsorStatus}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="clearboth pull-right pad-r-8">
                <button class="btn blue-button" (click)="onPCSponsorEligibilityChange()" tabindex="0"
                    type="submit" [disabled]="!enableSubmit" >
                    {{'config-system.SUBMIT' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
    </modal-content>
</modal>
<!-- Compose Email -->
<modal #composeEmail class="draft-email__modal modalwidth" (onOpen)="onComposeEmailPopupOpen()"
    (onClose)="onComposeEmailPopupClose()">
    <modal-header>
        <div class="color-blue bold">{{'customer-service.Compose Email Message' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}
                </span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div *ngIf="fboProfileDetail">
                <a *ngIf="(fboProfileDetail?.fboId || fboProfileDetail?.distributorId)"><i class="fa fa-copy"
                        [copyToClipboard]="(fboProfileDetail?.fboId || fboProfileDetail?.distributorId)"></i></a>
                <span *ngIf="fboProfileDetail.fboId">{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="!fboProfileDetail.fboId">{{fboProfileDetail.distributorId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.level ||fboProfileDetail.memberType"> | </span>
                <span>{{fboProfileDetail.level?fboProfileDetail.level:fboProfileDetail.memberType | titlecase}}</span>
            </div>
        </div>
        <div class="alert-msg error-content text-center" *ngIf="showErrorMsg">
            {{ 'customer-service.You do not have permission for any department in the selected operating country' |
            translate | translateKey }}
        </div>
        <div class="modalcontent-section compose-email" *ngIf="composeEmailForm">
            <form [formGroup]="composeEmailForm" (ngSubmit)="onSubmit(composeEmailForm.valid, composeEmailForm.value)">
                <!-- Operating Country -->
                <div class="col-xs-0 col-md-1"></div>
                <div class="col-xs-12 col-md-5 pt-20">
                    <label for="operatingcountry" class="control-label col-xs-5">{{'customer-service.Assigned to Country' |translate | translateKey}}</label>
                    <div class="floating-input col-md-12">
                        <select autofocus tabindex="0" formControlName="operatingCountry" class="form-control"
                            (change)="operatingCountryChange($event.target.value, true)">
                            <option value="" [selected]="true" disabled>--{{'ticketing-system.Select' |translate |
                                translateKey}}--</option>
                            <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">
                                {{country.name}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['operatingCountry'].valid && composeEmailForm.controls['operatingCountry'].hasError('required') &&(composeEmailForm.controls['operatingCountry'].touched|| isSubmitted)">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- From Address -->
                <div class="col-xs-12 col-md-5 pt-20">
                    <label for="fromaddress" class="control-label col-xs-5">{{'customer-service.From' |translate |
                        translateKey}}</label>
                    <div class="floating-input col-md-12">
                        <select class="form-control" formControlName="fromAddress"
                            (change)="changeFromAddress($event.target.value)">
                            <option value="" [selected]="true" disabled>--{{'ticketing-system.Select' |translate |
                                translateKey}}--</option>
                            <option *ngFor="let department of departments | orderBy:'email'" [value]="department.id">
                                {{department.email}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['fromAddress'].valid && composeEmailForm.controls['fromAddress'].hasError('required') &&(composeEmailForm.controls['fromAddress'].touched|| isSubmitted) && !showErrorMsg">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- To Address -->
                <div class="col-md-12 mt-10">
                    <span class="col-md-1 mt-7 pt-7">{{'customer-service.To' |translate |translateKey}}</span>
                    <div class="col-md-11 floatLabelContainer p-l-0">
                        <tag-input name="toAddress" [formControlName]="'toAddress'"
                            (onTextChange)="onTagsChange($event)" [errorMessages]="errorMessages"
                            [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                            placeholder="{{'customer-service.Add email' |translate |translateKey}}"
                            secondaryPlaceholder="{{'customer-service.Enter email address(es)' |translate |translateKey}}"
                            [addOnPaste]="true" [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
                        </tag-input>
                        <div class="alert-msg"
                            *ngIf="showToAddressValidation && !composeEmailForm.controls['toAddress'].valid && composeEmailForm.controls['toAddress'].hasError('required')&&(composeEmailForm.controls['toAddress'].touched || isSubmitted)">
                            {{'validation-message.Required' |translate |translateKey}}
                        </div>
                    </div>
                </div>
                <!-- CC -->
                <div class="col-md-12 mt-10">
                    <span class="col-md-1 mt-7 pt-7">{{'customer-service.CC' |translate |translateKey}}</span>
                    <div class="col-md-11 floatLabelContainer p-l-0">
                        <tag-input name="ccAddress" [formControlName]="'ccAddress'" [errorMessages]="errorMessages"
                            [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                            placeholder="{{'customer-service.Add email' |translate |translateKey}}"
                            secondaryPlaceholder="{{'customer-service.Enter email address(es)' |translate |translateKey}}"
                            [clearOnBlur]="false" [addOnPaste]="true" [addOnBlur]="true"
                            [pasteSplitPattern]="splitPattern" theme='bootstrap'>
                        </tag-input>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['ccAddress'].valid && composeEmailForm.controls['ccAddress'].hasError('emailValidationRuleForTicket') && !composeEmailForm.controls['ccAddress'].hasError('required') &&(composeEmailForm.controls['ccAddress'].touched|| isSubmitted)">
                            {{'customer-service.Enter valid Email'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- BCC -->
                <div class="col-md-12 mt-10">
                    <span class="col-md-1 mt-7 pt-7">{{'customer-service.BCC' |translate |translateKey}}</span>
                    <div class="col-md-11 floatLabelContainer p-l-0">
                        <tag-input name="bccAddress" [formControlName]="'bccAddress'" [errorMessages]="errorMessages"
                            [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                            placeholder="{{'customer-service.Add email' |translate |translateKey}}"
                            secondaryPlaceholder="{{'customer-service.Enter email address(es)' |translate |translateKey}}"
                            [clearOnBlur]="true" [addOnPaste]="true" [addOnBlur]="true"
                            [pasteSplitPattern]="splitPattern" theme='bootstrap'>
                        </tag-input>
                    </div>
                </div>
                <!-- Subject -->
                <div class="col-md-12 mt-10">
                    <span class="col-md-1 mt-7 pt-7">{{'customer-service.Subject' |translate |translateKey}}</span>
                    <div class="col-md-11 email__subject floatLabelContainer p-l-0">
                        <input float-label type="text" formControlName="subject" value="" class="" />
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['subject'].valid && composeEmailForm.controls['subject'].hasError('required') &&(composeEmailForm.controls['subject'].touched || isSubmitted)">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['subject'].valid && composeEmailForm.controls['subject'].hasError('maxlength') &&  (composeEmailForm.controls['subject'].touched || isSubmitted)">
                            {{'validation-message.Maximum length should be ||maxLength|| characters.' |translate |
                            translateKey:subjectMaxLength}}
                        </div>
                    </div>
                </div>
                <!-- CkEditor -->
                <div class="col-md-12 mt-10 ck-editorstyle ml-31" id="ckeditor-js">
                    <ckeditor [editor]="_editor" [config]="_config" [data]="bodyStr">
                    </ckeditor>
                </div>
                <!-- Ticket Type -->
                <div class="col-xs-12 col-md-4 pt-20 pl-0">
                    <label for="ticketType" class="control-label col-xs-5">{{'ticketing-system.Ticket Type' |translate |
                        translateKey}}</label>
                    <div class="floating-input col-md-11">
                        <select tabindex="0" formControlName="ticketType" (change)="getSubTypes($event.target.value)"
                            class="form-control">
                            <option value="" [selected]="true" disabled>--{{'ticketing-system.Select' |translate |
                                translateKey}}--</option>
                            <option *ngFor="let ticketType of ticketTypes | orderBy : 'sortValue'"
                                [value]="ticketType.id">
                                {{ticketType.value}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['ticketType'].valid && composeEmailForm.controls['ticketType'].hasError('required') &&(composeEmailForm.controls['ticketType'].touched|| isSubmitted)">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- Ticket SubType -->
                <div class="col-xs-12 col-md-4 pt-20">
                    <label for="subType" class="control-label col-xs-5">{{'ticketing-system.SubType' |translate |
                        translateKey}}</label>
                    <div class="floating-input col-md-11">
                        <select tabindex="0" formControlName="subType" class="form-control">
                            <option value="" [selected]="true" disabled>--{{'ticketing-system.Select' |translate |
                                translateKey}}--</option>
                            <option *ngFor="let subType of subTypes | orderBy : 'name'" [value]="subType.id">
                                {{subType.name}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['subType'].valid && composeEmailForm.controls['subType'].hasError('required') &&(composeEmailForm.controls['subType'].touched|| isSubmitted)">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- Status -->
                <div class="col-xs-12 col-md-4 pt-20">
                    <label for="status" class="control-label col-xs-5">{{'ticketing-system.Select' |translate |
                        translateKey}}</label>
                    <div class="floating-input col-md-11">
                        <select class="form-control" formControlName="statusId">
                            <option value="" disabled>--{{'ticketing-system.Status' |translate | translateKey}}--
                            </option>
                            <option *ngFor="let status of statuses" [value]="status.id">{{status.value}}</option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!composeEmailForm.controls['statusId'].valid && composeEmailForm.controls['statusId'].hasError('required') &&(composeEmailForm.controls['statusId'].touched|| isSubmitted)">
                            {{'validation-message.Required'|translate | translateKey}}
                        </div>
                    </div>
                </div>
                <!-- Attachments Grid -->
                <div class="row-sameheight-block">
                    <div class="col-xs-12 col-md-5 pt-20 column-equal ng-star-inserted">
                        <table class="table table-striped custab" id="file-upload-table">
                            <thead>
                                <tr>
                                    <th>{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>

                                    <th>{{'customer-service.Action' |translate | translateKey}}&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="uploader?.queue?.length">
                                <tr *ngFor="let item of uploader.queue">
                                    <td class="draft-attach">{{ item?.file?.name }}</td>
                                    <td class="options">
                                        <i class="line-height1-2 fa fa-trash"
                                            (click)="item.remove();attachmentsLength= attachmentsLength-1;"
                                            (click)="removeSize()"
                                            title="{{'ticketing-system.Delete'|translate | translateKey}}"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr class="text-center">
                                    <td colspan="2">{{'ticketing-system.Max 5 attachments allowed' |translate |
                                        translateKey}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-xs-12 col-md-3 pad-top-10 column-equal">
                        <label tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile"
                            class="mar-left10 line-height2 btn btn-xs browse-btn  bottom-25"
                            title="{{'ticketing-system.Choose File'|translate | translateKey}}">
                            <span aria-hidden="true">{{'ticketing-system.Choose File'|translate | translateKey}}</span>
                            <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader"
                                [disabled]="attachmentsLength==5 || isSendingEmail"
                                (change)="validateMessageAttachments()" role="file" aria-label="browse"
                                style="display: none;" multiple>
                        </label>
                    </div>
                </div>
                <div class="alert-msg error-content text-center" *ngIf="showMaxFileSizeValidation">
                    {{'customer-service.File Size exceeds'|translate | translateKey}} {{composeEmailattachmentMaxSize}}
                    {{'customer-service.MB size'|translate | translateKey}}</div>
                <div class="alert-msg error-content text-center" *ngIf="showEmailErrorMessage">{{message}}</div>
                <div class="pull-right mt-10" id="content-footer">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [disabled]="(!composeEmailForm.valid || isSendingEmail)">
                        <span>{{'customer-service.Send' | translate | translateKey }}
                            <i *ngIf="isSendingEmail" class="fa fa-spinner fa-spin"></i>
                        </span>
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closeComposeEmailPopup()"
                        [disabled]="isSendingEmail">
                        <span>{{'customer-service.Cancel' |translate | translateKey}}
                            <i *ngIf="isSendingEmail" class="fa fa-spinner fa-spin"></i>
                        </span>
                    </button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<!-- Compose Email -->

<!-- Retail Subscription starts -->
<modal #retailSubscriptionModal class="retail-subscription">
    <modal-header>
        <div class="color-black text-center font-weight-700 font-20" *ngIf="!isResubscribe">{{(isRetailSubscriptionLogin ?
            'customer-service.Shared Retail Subscription' : 'customer-service.Shared Retail Subscription Sign Up')
            |translate | translateKey}}</div>
            <div *ngIf="isResubscribe" class="color-black text-center font-weight-700 font-20">{{'customer-service.Shared Retail Subscription Resubscribe'|translate | translateKey}}</div>
            <div id="displayConfirmationMessage">
                <div *ngIf="showConfirmationMessage" [ngClass]="confirmationClass" [innerHtml]="confirmationMessage"></div>
            </div>
    </modal-header>
    <modal-content>
        <div class="retail-subscription-content modalcontent-section">
            <form *ngIf="retailSubscriptionForm" [formGroup]="retailSubscriptionForm" id="retail-subscription-form"
                (ngSubmit)="onSubmitRetailForm(retailSubscriptionForm.valid)">
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="firstName-input" float-label type="text" formControlName="firstName"
                            class="form-control" placeholder="{{'customer-service.First Name' |translate}}" disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['firstName'].hasError('required') && (retailSubscriptionForm.controls['firstName'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="lastName-input" float-label type="text" formControlName="lastName"
                            class="form-control" placeholder="{{'customer-service.Last Name' |translate}}" disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['lastName'].hasError('required') && (retailSubscriptionForm.controls['lastName'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="fboId-input" float-label type="text" formControlName="fboId" class="form-control"
                            placeholder=" {{'customer-service.FBO ID Number' |translate}}" disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['fboId'].hasError('required') && (retailSubscriptionForm.controls['fboId'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required'|translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="email-input" float-label type="text" formControlName="email" class="form-control"
                            placeholder="{{'customer-service.Email' |translate}}" />

                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['email'].hasError('required') && (retailSubscriptionForm.controls['email'].touched|| isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['email'].hasError('emailValidationRule') && !retailSubscriptionForm.controls['email'].hasError('required') && (retailSubscriptionForm.controls['email'].touched|| isRetailFormSubmitted)">
                            {{'customer-service.Enter valid Email'|translate}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="homeCountryStore-input" float-label type="text" formControlName="homeCountryStore"
                            class="form-control" placeholder="{{'customer-service.Home Country Store' |translate }}"
                            disabled />
                    </div>

                    <div  [ngClass]="hideBusinessEntityName?'col-md-6 floating-input':'d-none'" ></div>

                    <div  [ngClass]= "hideBusinessEntityName?' col-md-6 floating-input floatLabelContainer mt-20':'d-none'">
                        <input *ngIf="hideBusinessEntityName" id="taxId-input" float-label type="text" [attr.disabled]=true class="form-control" formControlName="businessEntityName"
                            placeholder="{{'order.Business Entity Name' |translate}}"  />
                    </div>

                    <div class="col-md-6 floating-input floatLabelContainer" [ngClass]= "hideBusinessEntityName? 'mt-20' :'' ">
                        <input id="taxId-input" float-label type="text" formControlName="taxId" class="form-control"
                            placeholder="{{'order.Tax ID' |translate}}/{{'order.VAT ID' |translate}}" disabled />
                        <span class="fa fa-question-circle-o pad-t-10 taxId" role="tooltip" [popover]="IdDescription"
                            placement="bottom" [outsideClick]="true" containerClass="tax-id-popover">
                        </span>
                        <ng-template #IdDescription>
                            <div>
                                <div>
                                    <span>{{'customer-service.TAX ID/VAT ID from this FBO’s account records that exempts them from paying tax on the subscription purchase'|translate}}</span>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 ">
                        <div class="cart-section">
                            <label for="address" class="address_label">{{'customer-service.Address' |translate}}</label>
                            <address class="retail_modal_address">
                                <span *ngIf="retailSubscriptionForm.get('address.line1').value">{{retailSubscriptionForm.get('address.line1').value}} <br></span>
                                <span *ngIf="retailSubscriptionForm.get('address.line2').value">{{retailSubscriptionForm.get('address.line2').value}} <br></span>
                                <span *ngIf="retailSubscriptionForm.get('address.line3').value">{{retailSubscriptionForm.get('address.line3').value}}<br></span>
                                <span *ngIf="retailSubscriptionForm.get('address.line4').value">{{retailSubscriptionForm.get('address.line4').value}}<br></span>
                                <span *ngIf="retailSubscriptionForm.get('address.city').value">{{retailSubscriptionForm.get('address.city').value}}, </span>
                                <span *ngIf="retailSubscriptionForm.get('address.state').value">{{retailSubscriptionForm.get('address.state').value}} </span>
                                <span *ngIf="retailSubscriptionForm.get('address.postalCode').value">{{retailSubscriptionForm.get('address.postalCode').value}} <br> </span>
                                <span>{{retailSubscriptionForm.get('address.Country').value}} </span>
                            </address>
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <select class="form-control" float-label formControlName="language" id="language"
                            attr.data-placeholder="{{'customer-service.Language' | translate}}">
                            <option value="" disabled>{{'customer-service.Select Language' |translate }}
                            </option>
                            <option *ngFor="let language of languages" [ngValue]="language.id">{{language.name}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['language'].hasError('required') && (retailSubscriptionForm.controls['language'].touched || isRetailFormSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                </div>

                <div class="col-md-12 mt-20">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="chargseBeeRetailPlanId-input" float-label type="text"
                            formControlName="chargeBeeRetailPlanId" class="form-control planId"
                            placeholder="{{'customer-service.Chargebee Shared Retail Plan ID' |translate | translateKey}}"
                            disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['chargeBeeRetailPlanId'].hasError('required') && (retailSubscriptionForm.controls['chargeBeeRetailPlanId'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="annualSubscriptionFee-input" float-label type="text"
                            formControlName="annualSubscriptionFee" class="form-control"
                            placeholder="{{'customer-service.Annual Subscription Fee' |translate}}" disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['annualSubscriptionFee'].hasError('required') && (retailSubscriptionForm.controls['annualSubscriptionFee'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-20" *ngIf="isRetailSubscriptionLogin">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input id="subscriptionStatus-input" float-label type="text"
                            formControlName="subscriptionStatus" class="form-control"
                            placeholder="{{'customer-service.Subscription Status' |translate}}" disabled />
                        <div class="alert-msg"
                            *ngIf="retailSubscriptionForm.controls['subscriptionStatus'].hasError('required') && (retailSubscriptionForm.controls['subscriptionStatus'].touched || isRetailFormSubmitted)">
                            {{'customer-service.Required' |translate}}
                        </div>
                    </div>
                </div>
                <div class="pull-right pad-r-8 mt-20" *ngIf="!isRetailSubscriptionLogin">
                    <button *ngIf="!isResubscribe" class="btn blue-button" tabindex="0" type="submit"
                        [attr.disabled]="(retailSubscriptionForm.valid) ?null:''"> {{'customer-service.SUBSCRIBE'
                        |translate}}</button>
                        <button *ngIf="isResubscribe" class="btn blue-button" tabindex="0" type="submit"
                        [attr.disabled]="(retailSubscriptionForm.valid) ?null:''"> {{'customer-service.RESUBSCRIBE'
                        |translate}}</button>
                    <button class="btn grey-button" tabindex="0" type="button"
                        (click)="closePopUpforRetailSubscription()">
                        {{'config-system.CANCEL' |translate}}
                    </button>
                </div>
                <div class="pull-right pad-r-8 mt-20 " *ngIf="isRetailSubscriptionLogin">
                    <button class="btn blue-button" tabindex="0" type="submit"
                        [attr.disabled]="(retailSubscriptionForm.valid && retailSubscriptionForm.dirty && !isSubscriptionCreatedInChargebee) ?null:''">
                        {{'config-system.UPDATE'
                        |translate}}</button>
                    <button class="btn grey-button" tabindex="0" type="button"
                        (click)="closePopUpforRetailSubscription()">
                        {{'customer-service.CLOSE' |translate}}
                    </button>
                </div>
            </form>
            <div *ngIf="isRetailSubscriptionLogin && !isSubscriptionCreatedInChargebee">
                <div class="col-md-12 mt-20">
                    <div class="col-md-6 pad-l-30">
                        <div class="pad-bottom-10"
                            *ngIf="memberRetailSubscriptionDetail.subscriptionStatus === subscriptionStatusEnum.Pending">
                            <a href="/" onclick="return false;"
                                (click)="resendSignupEmail(fboProfileDetail.distributorId)">{{'customer-service.Resend Sign Up Email' | translate}}</a>
                        </div>
                        <div class="pad-bottom-10" *ngIf="memberRetailSubscriptionDetail?.subscriptionStatus != subscriptionStatusEnum.Cancelled">
                            <a href="/" onclick="return false;"
                                (click)="sendAcceptTermsEmail(fboProfileDetail.distributorId)">{{'customer-service.Send Accept Terms Email' | translate}}</a>
                        </div>
                        <div class="pad-bottom-10" *ngIf="memberRetailSubscriptionDetail?.subscriptionStatus != subscriptionStatusEnum.Cancelled">
                            <a href="/" onclick="return false;"
                                (click)="sendChangePaymentLinkEmail(fboProfileDetail.distributorId)">{{'customer-service.Send Change Payment Email' |translate}}</a>
                        </div>
                    </div>
                    <div class="col-md-6 pad-l-30">
                        <div class="pad-bottom-10" *ngIf="showBillingHistoryLink">
                            <a href="/" onclick="return false;" (click)="openBillingHistory()">{{'customer-service.View Billing History' |
                                translate}}</a>
                        </div>
                        <div class="pad-bottom-10" *ngIf="showSubscriptionHistoryLink">
                            <a  (click)="openViewSubscriptionHistory()">{{'customer-service.View Subscription History' |translate}}</a>
                        </div>
                        <div class="pad-bottom-10"
                            *ngIf="memberRetailSubscriptionDetail.subscriptionStatus === subscriptionStatusEnum.Active">
                            <a href="/" onclick="return false;"
                                (click)="openCancelRenewalModal()">{{'customer-service.Cancel Renewal' |translate}}</a>
                        </div>
                        <div class="pad-bottom-10"
                            *ngIf="memberRetailSubscriptionDetail.subscriptionStatus === subscriptionStatusEnum.Active">
                            <a href="/" onclick="return false;"
                                (click)="openCancelSubscriptionModal()">{{'customer-service.Cancel Subscription'
                                |translate}}</a>
                        </div>
                        <div class="pad-bottom-10"
                            *ngIf="memberRetailSubscriptionDetail.subscriptionStatus === subscriptionStatusEnum.Cancelled">
                            <a href="/" onclick="return false;" (click)="resubscription()">{{'customer-service.ReSubscribe'
                                |translate}}</a>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div *ngIf="showConfirmationMessage" [ngClass]="confirmationClass" [innerHtml]="confirmationMessage"></div> -->
        </div>
    </modal-content>
</modal>
<modal #cancelRenewalModal class="cancel-renewal">
    <modal-header>
        <div class="color-blue">{{'customer-service.Cancel Renewal' |translate}}</div>
    </modal-header>
    <modal-content>
        <div>
            {{'customer-service.Are you sure you want to cancel the renewal of this subscription?' |translate}}
        </div>
        <div class="clearboth pull-right mt-20">
            <button class="btn blue-button"
                (click)="cancelRenewalSubscription(fboProfileDetail.distributorId)">{{'customer-service.Yes'
                |translate}}</button>
            <button class="btn grey-button" (click)="closeCancelRenewalSubscriptionModal()">{{'customer-service.No'
                |translate}}</button>
        </div>
    </modal-content>
</modal>

<modal #cancelSubscriptionModal class="cancel-subscription">
    <modal-header>
        <div class="color-blue">{{'customer-service.Cancel Subscription' |translate}}</div>
    </modal-header>
    <modal-content>
        <div>
            {{'customer-service.Are you sure you want to cancel this subscription immediately?' |translate}}
        </div>
        <div class="clearboth pull-right mt-20">
            <button class="btn blue-button"
                (click)="cancelSubscription(fboProfileDetail.distributorId)">{{'customer-service.Yes' |translate}}</button>
            <button class="btn grey-button" (click)="closeCancelSubscriptionModal()">{{'customer-service.No'
                |translate}}</button>
        </div>
    </modal-content>
</modal>

<!-- Retail Subscription ends -->

<!-- View Subscription History Starts -->
<modal #viewSubscriptionHistoryModal class="view-subscription-history">
    <modal-header>
        <div class="modal_header">
            <div class="modal_header_left_icon">
                <i class="fa fa-angle-left pointer" aria-hidden="true" (click)="closeViewSubscriptionHistory()"> </i>
            </div>
            <div class="modal_header_name">
                {{'customer-service.Subscription history' |translate}}
            </div>
        </div>
    </modal-header>
    <modal-content>
        <div class="model_content_view_subscription_history">
            <div style="transition:.2s linear" *ngFor="let subscriptionHistory of loadRetailSubscriptionHistory; let i = index">
                <div class="subscription_history parent" style="transition:.2s linear" id="{{i}}">
                    <div class="subscription_history child_1">
                        <div class="list">
                            <ul>
                                <li class="list_element_color"></li>
                            </ul>
                        </div>
                        <div class="content">
                            <div>{{subscriptionHistory?.planCode}}</div>
                            <div>
                                <span>{{subscriptionHistory?.subscriptionAmount | number:'1.2-2' }}</span>
                                <span>{{subscriptionHistory?.currencyCode}}</span>
                                <span>{{subscriptionHistory?.createdDate | date: 'MMMM d, y'}}</span>
                            </div>
                            <div>
                                <span>{{'customer-service.Status'| translate}} {{subscriptionHistory?.subscriptionStatus ? ':' : ''}}</span>
                                <span *ngIf="subscriptionHistory?.subscriptionStatus"> {{subscriptionStatusEnum[subscriptionHistory?.subscriptionStatus]}}</span>
                            </div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal-content>
    <modal-footer>
        <div class="footer_content" align="center">
            <button class="btn blue-button" (click)="loadMore()"
                [disabled]="loadRetailSubscriptionHistory?.length==retailSubscriptionHistoryResponse?.length"> Load More
            </button>
        </div>

    </modal-footer>
</modal>
<!-- View Subscription History Ends -->



<modal #accountRestrictionModal>
    <modal-header>
        <div class="color-blue">{{'customer-service.ACCOUNT NOTIFICATION' |translate}}</div>
    </modal-header>
    <modal-content>
        <div class="">{{'customer-service.Marking this account as Restricted will limit the ability of CSP users who do not have this specific permission to search for and open this account. Those users will not be able to view any details, make changes, create orders, view reports, etc.' |translate}}</div>
        <div class="row mt-20">
            <div class="col-md-6 mb-10">
                <input tabindex="0" type="checkbox" [(ngModel)]="isAccountChecked" [checked]="isAccountChecked">
                <label>
                    &nbsp;{{'customer-service.Restricted' |translate }}
                </label>
            </div>
        </div>
        <div class="clearboth text-right mt-40">
            <button class="btn blue-button" tabindex="0" type="button" [attr.disabled]="fboProfileDetail.emailId ? null:''" (click)="submitAccountRestrictionPopup(isAccountChecked?'Checked':'unchecked')">
                {{'config-system.UPDATE' |translate}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="cancelAccountRestrictionPopup()">
                {{'config-system.CANCEL' |translate}}
            </button>
        </div>
    </modal-content>
</modal>
<div *ngIf="accountRestriction">
    <account-restriction-popup [memberDetails]="memberDetails" (closeModal)="closeModal($event)"></account-restriction-popup>
</div>

<section class="container cart-section">
    <div class="cart-block"
        *ngIf="viewShoppingBagPermission && !isGuestMemberType && fboProfileDetail && fboProfileDetail.memberTypeId">
        <!-- <a *ngIf="shoppingCartCount" [routerLink]="['/customerservice/orders']" routerLinkActive="active" target="_blank" (click)="gotoCheckout()">
            <span class="shopping-bag-icon"></span>
            <span class="cart-count">
                {{shoppingCartCount}}
            </span>
        </a>
        <a class="cart" *ngIf="!shoppingCartCount">
            <span class="shopping-bag-icon float-right"></span>
        </a> -->
    </div>
    <div class="col-md-7 left-padding-0">
        <div class="col-md-6 left-padding-0">
            <div>
                <span class="header-font bold memberInfoName">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div class="memberId">
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail?.fboId"></i></a><span class="pl-5">{{fboProfileDetail.fboId
                    |distributorIdFormat}} </span>
                <!-- <span *ngIf="fboProfileDetail.memberLevel"> | </span> -->

                <!-- <a [routerLink]=""
                    *ngIf="fboProfileDetail && fboProfileDetail.operatingCountry && !isGuestMemberType && viewMemberLevelAllowed && isDisplayMemberTitle"
                    (keyup.enter)="viewMemberLevel()" (click)="viewMemberLevel()">{{fboProfileDetail.memberLevel |
                    titlecase}}
                </a> -->
                <!-- <span
                    *ngIf="fboProfileDetail && isDisplayMemberTitle">{{fboProfileDetail.memberLevel
                    | titlecase}} </span> -->

            </div>
            <div>
                <div *ngIf="fboProfileDetail && isDisplayMemberTitle">
                    <span class="fa fa-question-circle-o" role="tooltip" [popover]="wrkLevelDescription"
                        placement="bottom" [outsideClick]="true" containerClass="member-level-popover">
                    </span>
                    <span class="memberLevelInfo">{{'customer-service.Working Level' | translate | translateKey}}</span>
                    <span class="padding-right">-</span>
                    <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
                </div>
                <ng-template #wrkLevelDescription>
                    <div>
                        <div>
                            <span>Updated daily based upon current months order and case credit activity.</span>
                        </div>
                    </div>
                </ng-template>
                <div class="levelmargin"
                    *ngIf="fboProfileDetail && fboProfileDetail.accountLevelTitle && isDisplayMemberTitle">
                    <span class="fa fa-question-circle-o" [popover]="perLevelDescription" placement="bottom"
                        [outsideClick]="true" containerClass="member-level-popover">
                    </span>
                    <span class="memberLevelInfo">{{'customer-service.Permanent Level' | translate |
                        translateKey}}</span>
                    <span>-</span>
                    <span *ngIf="!isGuestMemberType">{{fboProfileDetail.accountLevelTitle | titlecase}}</span>
                    <span *ngIf="isGuestMemberType">{{fboProfileDetail.memberLevel | titlecase}}</span>
                </div>
                <ng-template #perLevelDescription>
                    <div>
                        <div>
                            <span>Highest Level achieved. Updated monthly as part of monthly commission payouts. Does not include current month case credit activity.</span>
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="line-height-25">
                <div class="profileImg-padding">
                    <img src="{{profileImage}}" err-img fallbackImageUrl="/images/no_pro_pic.jpg"
                        alt="" class="fbo-profileImage" />
                </div>

                <div
                    *ngIf="fboProfileDetail && fboProfileDetail.memberId && !isGuestMemberType && (impersonationPermission | hasAccess : customerServiceAccessLevelId) && fboProfileDetail.fboId && fboProfileDetail.address && fboProfileDetail.address.country && memberStatus && memberStatus.name !== 'Terminated'">
                    <a href="/" onclick="return false;" tabindex="0" (click)="enableFBOLogin? impersonateUser() : ''"
                        (keyup.enter)="impersonateUser()">{{'customer-service.FBO Login' |translate}}</a>
                </div>
                <div
                    *ngIf="(!flp360TitanWebsiteEnabled && isFlp360Enabled && !isGuestMemberType && (flp360ImpersonationPermission | hasAccess : customerServiceAccessLevelId) && fboProfileDetail && fboProfileDetail.fboId) && updateAccessToTitanCounty">
                    <a href="/" onclick="return false;" tabindex="0" (click)="impersonateFlp360User()"
                        (keyup.enter)="impersonateFlp360User()">{{'customer-service.FLP360 Login' |translate}}</a>
                </div>
                <div
                    *ngIf="!enableFLP360ImpersonationForFPC && flp360TitanWebsiteEnabled && isFlp360Enabled && !isGuestMemberType && (flp360ImpersonationPermission | hasAccess : customerServiceAccessLevelId) && fboProfileDetail && fboProfileDetail.fboId">
                    <a href="/" onclick="return false;" tabindex="0" (click)="impersonateFlp360WebsiteUser()"
                        appNoDblClick (keyup.enter)="impersonateFlp360WebsiteUser()">{{'customer-service.FLP360 Website Login' |translate}}</a>
                </div>
                <div
                    *ngIf="enableFLP360ImpersonationForFPC && (isDistributor || isPrefferedCustomer) && !isGuestMemberType && (flp360ImpersonationPermission | hasAccess : customerServiceAccessLevelId) && fboProfileDetail && fboProfileDetail.fboId">
                    <a href="/" onclick="return false;" tabindex="0" (click)="impersonateFlp360WebsiteUser()"
                        appNoDblClick (keyup.enter)="impersonateFlp360WebsiteUser()">{{'customer-service.FLP360 Website Login' |translate}}</a>
                </div>
                <div>
                    <a href="/" onclick="return false;"
                        *ngIf="(isMemberTypeDistributor && hasRetailSubscriptionAccess && isStoreRetailSubscriptionEnabled &&  !enableAmazonSubscriptionFlag && ((isTitanEnabled && !isBetaEnabled) || isMemberRecordExistInTitan)) && updateAccessToTitanCounty"
                        (click)="openRetailSubscriptionModal()"
                        (keyup.enter)="openRetailSubscriptionModal()">{{(isRetailSubscriptionLogin ?
                        'customer-service.Shared Retail Subscription Login' : 'customer-service.Shared Retail
                        Subscription Sign Up') |translate | translateKey }}</a>
                </div>
                <div *ngIf="fboProfileDetail.memberId && !isGuestMemberType && resetPasswordPermission && fboProfileDetail.fboId"
                    class="">
                    <a href="/" onclick="return false;" tabindex="0"
                        [attr.disabled]="fboProfileDetail.emailId ? null:''" (click)="openResetPasswordModal()"
                        (keyup.enter)="openResetPasswordModal()">{{'customer-service.Reset Password' |translate}}</a>
                </div>
                <div *ngIf="(fboProfileDetail && !fboProfileDetail.memberId && flp360AccountAvailable && !isGuestMemberType && (flp360ResetPasswordPermission | hasAccess : customerServiceAccessLevelId) && fboProfileDetail.fboId) && updateAccessToTitanCounty"
                    class="">
                    <a href="/" onclick="return false;" tabindex="0" (click)="openFlp360ResetPasswordModal()"
                        (keyup.enter)="openFlp360ResetPasswordModal()">{{'customer-service.Flp360 Reset Password'
                        |translate}}</a>
                </div>
                <div>
                    <a [routerLink]="" tabindex="0" *ngIf="allowResetAccountPermission && updateAccessToTitanCounty">{{'customer-service.Reset Account' |translate}}</a>
                </div>
                <div>
                    <a tabindex="0" (click)="openUnlockModal(true)"
                        *ngIf="unlockPermission && (isTitanEnabled || isMemberRecordExistInTitan) && !isGuestMemberType">{{'customer-service.Unlock'
                        |translate |translateKey}}</a>

                </div>
                <div>
                    <a [routerLink]="" tabindex="0"
                        *ngIf="(allowFullNamePermission && (isTitanEnabled && !isBetaEnabled)) && updateAccessToTitanCounty"
                        (click)="openChangeNameModal()">{{'customer-service.Update Name' |translate |translateKey}}</a>
                </div>
                <div>
                    <a [routerLink]="" tabindex="0" (click)="openChangeEmailModal()"
                        *ngIf="((isTitanEnabled && !isBetaEnabled)  && changeEmailPermission) && updateAccessToTitanCounty">{{'customer-service.Update Email Address'
                        |translate |translateKey}}</a>
                </div>
                <div *ngIf="((isTitanEnabled && !isBetaEnabled) && (updatePhoneNumberPermission) && updateAccessToTitanCounty)">
                    <a [routerLink]="" tabindex="0" (click)="openUpdatePhoneNumberModal()">{{'customer-service.Update Phone Number' |translate |translateKey}}</a>
                </div>
                <div>
                    <a tabindex="0" (click)="openChangeHomeCountryModal(changeHomeCountry)"
                        *ngIf="(homeCountryPermission && (isTitanEnabled && !isBetaEnabled) && enableChangeHomeCountry) && updateAccessToTitanCounty">{{'customer-service.Change Address' |translate |translateKey}}</a>
                </div>
                <div>
                    <a tabindex="0" (click)="openChangeStatusModal()"
                        *ngIf="(statusEditPermission && (isTitanEnabled && !isBetaEnabled) && enableChangeStatus) && updateAccessToTitanCounty">{{'customer-service.Change Status' |translate |translateKey}}</a>

                </div>
                <div>
                    <a tabindex="0" (click)="openChangeMemberPreferences()"
                        *ngIf="(changeMemberPreferencesPermission && (isTitanEnabled && !isBetaEnabled))&& updateAccessToTitanCounty">{{'customer-service.Change Member Preferences' |translate |translateKey}}</a>
                </div>
                <!-- Please dont remove / un-comment the below block as this will be used in phase 2 -->

                <div>
                    <a [routerLink]="" tabindex="0" (click)="openChangeSponsorModal()"
                        *ngIf="(enableSponsorChange && isAgentAllowedToChangeSponsor && fboProfileDetail.memberStatus === statusActive && (isTitanEnabled && !isBetaEnabled)) && updateAccessToTitanCounty">{{'customer-service.Change Sponsor' |translate |translateKey}}</a>
                </div>
                <!-- <div>
                    <a [routerLink]="" tabindex="0" (click)="openChangeMemberTypeandLevelModal()" *ngIf="memberTypePermission && isTitanEnabled && enableMemberTypeOrLevel">{{'customer-service.Member Type or Wholesale Qualification' |translate |translateKey}}</a>

                </div> -->

                <div>
                    <a [routerLink]="" tabindex="0" (click)="openOverrideMonthlyCCLimitModal()"
                        *ngIf="(enableMemberCCOverride && monthlyCCLimitPermission && ((isTitanEnabled && !isBetaEnabled) || isMemberRecordExistInTitan)) && updateAccessToTitanCounty">{{'customer-service.Change Monthly CC Limit' |translate |translateKey}}</a>

                </div>
                <div>
                    <a [routerLink]="" tabindex="0" (click)="openChangeGovtIDModal()"
                        *ngIf="(governmentIdViewPermission && (isTitanEnabled && !isBetaEnabled) && enableGovernmentID) && updateAccessToTitanCounty">{{'Manage Government IDs'}}</a>
                </div>
                <div
                    *ngIf="this.appConfig && this.appConfig?.bondedWarehouseProject && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR && ( this.bondedWarehouseProjectViewPermission || this.bondedWarehouseProjectManagePermission )">
                    <a [routerLink]="" tabindex="0" (click)="openBondedWarehouseProjectModal()">{{'Bonded Warehouse Project'}}</a>
                </div>
                <div>
                    <a href="/" onclick="return false;" tabindex="0" (click)="openChangeBusinessEntityModal()"
                        *ngIf="(businessEditEntityPermission && (isTitanEnabled && !isBetaEnabled) && isDistributor && !disableBusinessEntityForFbo) && updateAccessToTitanCounty">{{'customer-service.Change Business Entity' |translate}}</a>
                </div>

                <div>
                    <a [routerLink]="" tabindex="0" (click)="openUpdateDOBModal()"
                        *ngIf="((isTitanEnabled && !isBetaEnabled) && enableChangeDOB && updateDOBPermission) && updateAccessToTitanCounty">{{'customer-service.Change DOB'
                        |translate |translateKey}}</a>
                </div>

                <div>
                    <a [routerLink]="" tabindex="0" (click)="openUpdateBonusInfoModal()"
                        *ngIf="((isTitanEnabled && !isBetaEnabled) && personalInfoSettings && personalInfoSettings.enableSingleAndDirectDebit && (isDistributor || (isPrefferedCustomer && isFpcEligibleForPcSponsor)) && (hasFboBonusInfoViewPermission || hasFboBonusInfoDeletePermission || hasFboBonusInfoManagePermission)) && updateAccessToTitanCounty">
                        <span>{{'Bonus/Debit Information'}}</span>
                    </a>
                </div>
                <div>
                    <a [routerLink]="" tabindex="0" (click)="openSingleAndDirectDebitModal()"
                    *ngIf="(showSingleAndDirectDebitMenu && personalInfoSettings && personalInfoSettings.enableSingleAndDirectDebit && isDistributor && (singleAndDirectDebitManagePermission || singleAndDirectDebitViewPermission)) && updateAccessToTitanCounty">
                        <span>{{'Single/Direct Debit'}}</span>
                    </a>
                </div>
                <div>
                    <a [routerLink]="" tabindex="0" (click)="openChangeAccountNotificationModal()"
                        *ngIf="(((isTitanEnabled && !isBetaEnabled) || isMemberRecordExistInTitan) && !isGuestMemberType && accountNotificationPermission) && updateAccessToTitanCounty">{{'customer-service.Account Notification' |translate |translateKey}}</a>
                </div>
                <div>
                    <a tabindex="0" (click)="showComposeEmailPopup()"
                        *ngIf="(composeEmailPermission && isTitanEnabled)&& updateAccessToTitanCounty">{{'customer-service.Compose Email' |translate
                        |translateKey}}</a>
                </div>
                <div *ngIf="(accountViewPermission && isTitanEnabled)&& updateAccessToTitanCounty">
                    <a tabindex="0" (click)="showAccountRestrictionPopup()">
                        {{'customer-service.Account Restriction' |translate}}</a>
                </div>
                <!-- <br> -->
                <div>
                    <a [routerLink]="" tabindex="0" *ngIf="(hasAllowEcheckPermission && showPayByAccountCheck)&& updateAccessToTitanCounty"
                        (click)="openPayByCheckAccountModal(null,true)">{{'customer-service.Pay by Check Account Info'
                        |translate |translateKey}}
                    </a>
                </div>
                <div>
                    <a tabindex="0" *ngIf = "(isPrefferedCustomer || fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR) && enableUpdatePCSponsor" (click)="updatePCSponsorEligibility()">{{'customer-service.PC Sponsorship Eligibility' |translate |translateKey}}</a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="pad-bottom-15">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.ACCOUNT INFORMATION' |translate
                            |translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Member Status' |translate | translateKey}}
                    </div>
                    <div
                        class="col-md-6 no-padding text-right {{ memberStatus && memberStatus.name ? memberStatus.name : externalMemberStatus}} ">
                        <span *ngIf="memberStatus">{{memberStatus.name}}</span>
                        <span *ngIf="!memberStatus && externalMemberStatus"
                            class="text-capitalize">{{externalMemberStatus}}</span>
                        <span *ngIf="!memberStatus && !externalMemberStatus">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Enrollment Date' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="isEnrollmentDateExists">{{fboProfileDetail.enrollmentDate | date:
                            'dd-MMM-yyyy'}}</span>
                        <span *ngIf="!isEnrollmentDateExists">{{'customer-service.NA' |translate | translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Opt In Date' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.optinDate">{{fboProfileDetail.optinDate | date:
                            'dd-MMM-yyyy'}}</span>
                        <span *ngIf="!fboProfileDetail.optinDate">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.First Purchase Date' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="isfirstPurchaseDateEmpty===false">{{fboProfileDetail.firstPurchaseDate| date:
                            'MMM-yyyy'}}
                        </span>
                        <span *ngIf="isfirstPurchaseDateEmpty===true">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row" *ngIf="fboProfileDetail.memberTypeId != memberTypeEnum.GUEST &&
                   fboProfileDetail.memberTypeId != memberTypeEnum.RETAIL">
                    <div class="col-md-8 no-padding">
                        {{'customer-service.Wholesale Qualified' |translate | translateKey}}
                    <span role="tooltip" popover="{{'common.The Wholesale Qualification status of this account is based on the current Case Credit balance.' |translate |translateKey}}"  placement="bottom"
                        [outsideClick]="true" containerClass="discount-popover">
                        <i class="fa fa-question-circle-o"></i>
                    </span>
                    </div>
                    <div class="col-md-4 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.wholesaleQualifiedCheck">{{'customer-service.YES'
                            |translate |
                            translateKey}}</span>
                        <span
                            *ngIf="fboProfileDetail && !fboProfileDetail.wholesaleQualifiedCheck">{{'customer-service.NO'
                            |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row" *ngIf="fboProfileDetail.memberTypeId != memberTypeEnum.GUEST &&
                   fboProfileDetail.memberTypeId != memberTypeEnum.RETAIL">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Discount' |translate | translateKey}}
                        <span role="tooltip" popover="{{'common.FPCs receive a base discount of 5% or a 30% Wholesale discount' |translate |translateKey}}{{'.'}}{{'common.FBOs receive the 30% Wholesale discount and may be eligible for additional discounts between 0% and 18%' |translate |translateKey}}"  placement="bottom"
                            [outsideClick]="true" containerClass="discount-popover">
                            <i class="fa fa-question-circle-o"></i>
                        </span>
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <!-- <span *ngIf="fboProfileDetail && fboProfileDetail.wholesaleQualifiedCheck && memberDiscountPercentage && memberDiscountPercentage.discountPercentage > -1">30% / {{memberDiscountPercentage.discountPercentage}}%</span> -->
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.wholesaleQualifiedCheck 
                            && memberDiscountPercentage && memberDiscountPercentage.discountPercentage > -1">30%
                            / <span>{{ (this.fboProfileDetail.memberOptin == false) || (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC) ? 0 :
                                memberDiscountPercentage.discountPercentage}}%</span> </span>
                        <!-- <span *ngIf="fboProfileDetail && !fboProfileDetail.wholesaleQualifiedCheck && memberDiscountPercentage && memberDiscountPercentage.discountPercentage > -1">5% / {{memberDiscountPercentage.discountPercentage}}%</span> -->
                        <span
                            *ngIf="fboProfileDetail && !fboProfileDetail.wholesaleQualifiedCheck && memberDiscountPercentage && memberDiscountPercentage.discountPercentage > -1">5%
                            / <span>{{ this.fboProfileDetail.memberOptin == false ? 0 :
                                memberDiscountPercentage.discountPercentage}}%</span>
                        </span>

                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Government ID' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.governmentId">{{fboProfileDetail.governmentId}}</span>
                        <span *ngIf="!fboProfileDetail.governmentId">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div> -->

                <div class="row" *ngIf="(isPrefferedCustomer || fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR)">
                 <div class="col-md-8 no-padding">
                     {{'customer-service.Eligible to Sponsor' |translate | translateKey}}
                 <span role="tooltip" popover="{{'common.The Eligible to Sponsor status is based on Minimum CC threshold qualification' |translate |translateKey}}"  placement="bottom"
                     [outsideClick]="true" containerClass="discount-popover">
                     <i class="fa fa-question-circle-o"></i>
                 </span>
                 </div>
                 <div class="col-md-4 no-padding text-right">
                     <span>{{isFpcEligibleForPcSponsor ? ('customer-service.YES' |translate | translateKey) : ('customer-service.NO' |translate | translateKey)}}</span>
                 </div>
             </div>
            </div>
            <div class="pad-bottom-15">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.PERSONAL INFORMATION' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row" *ngIf="fboProfileDetail.address">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Address' |translate |translateKey}}
                    </div>

                    <div *ngIf="!addressFirstLine" class="col-md-9  text-right no-padding">
                        <span>{{'customer-service.NA' |translate | translateKey}}</span>
                    </div>
                    <div *ngIf="addressFirstLine" class="col-md-9 no-padding text-right">
                        <span>{{ addressFirstLine}}</span>
                    </div>
                    <!-- <div *ngIf="fboProfileDetail.address.addressSecondLine" class="col-md-6 col-md-offset-6 text-right no-padding">
                        <span>{{fboProfileDetail.address.addressSecondLine | titlecase}}</span>
                    </div>
                    <div *ngIf="fboProfileDetail.address.addressThirdLine" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboProfileDetail.address.addressThirdLine | titlecase}}</span>
                    </div> -->
                    <div *ngIf="addressSecondLine" class="col-md-9 col-md-offset-3 no-padding text-right">
                        <span>{{addressSecondLine}}</span>
                    </div>
                    <div *ngIf="fboProfileDetail.address.zipCode"
                        class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboProfileDetail.address.zipCode | uppercase}}</span>
                    </div>
                    <!-- <div *ngIf="fboProfileDetail.address.state" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboProfileDetail.address.state | titlecase}}</span>
                    </div> -->
                    <div *ngIf="fboProfileDetail.address.country"
                        class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboProfileCountry}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Email' |translate | translateKey}}
                    </div>
                    <div class="col-md-9 no-padding text-right word-break--overflow">
                        <span *ngIf="fboProfileDetail.emailId">
                            <a href="mailto:{{fboProfileDetail.emailId}}">{{fboProfileDetail.emailId | lowercase}}</a>
                        </span>
                        <span *ngIf="!fboProfileDetail.emailId">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Mobile Phone' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.mobile && phoneNumberFormat">{{fboProfileDetail.mobile | mask:
                            phoneNumberFormat}}</span>
                        <span *ngIf="fboProfileDetail.mobile && !phoneNumberFormat">{{fboProfileDetail.mobile}}</span>
                        <span *ngIf="!fboProfileDetail.mobile">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Home Phone' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.homePhoneNumber">{{fboProfileDetail.homePhoneNumber | mask:
                            phoneNumberFormat}}</span>
                        <span *ngIf="!fboProfileDetail.homePhoneNumber">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="enableChangeDOB">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Date Of Birth' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.birthDate">{{fboProfileDetail.birthDate |
                            date:'dd-MMM-yyyy'}}</span>
                        <span *ngIf="!fboProfileDetail.birthDate">{{'customer-service.NA' |translate
                            |translateKey}}</span>
                    </div>
                </div>
            </div>
            <div class="pad-bottom-15"
                *ngIf="memberType === 'FBO' || memberType === 'Distributor' || memberType === 'FPC'">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.FLP360' |translate | translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Enrolled' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        {{ isFlp360Enrolled }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Subscription Status' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="flp360Status">{{flp360Status}}</span>
                        <span *ngIf="!flp360Status">{{'customer-service.NA' |translate |translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Enrollment Date' |translate}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="flp360EnrollmentDate">{{ flp360EnrollmentDate | date:'dd-MMM-yyyy'}}</span>
                        <span *ngIf="!flp360EnrollmentDate">{{'customer-service.NA' |translate | translateKey}}</span>
                    </div>
                </div>

            </div>
            <div class="pad-bottom-15">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.PREFERENCES' |translate | translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Language' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span *ngIf="fboProfileDetail.preferredLanguage">{{fboProfileDetail.preferredLanguage}}</span>
                        <span *ngIf="!fboProfileDetail.preferredLanguage">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 no-padding">
                        {{'customer-service.Privacy Requested' |translate}}
                    </div>
                    <div class="col-md-2 no-padding text-right">
                        <span [class.ERROR]="fboProfileDetail.memberPreference === 'Yes'"
                            *ngIf="fboProfileDetail.memberPreference">{{'user.'+fboProfileDetail.memberPreference
                            |translate }}</span>
                        <span *ngIf="!fboProfileDetail.memberPreference">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row" *ngIf="isDistributor && enableAmazonSubscriptionFlag">
                    <div class="col-md-10 no-padding">
                        {{'customer-service.Amazon Subscription Program Agreement' | translate | translateKey}}
                    </div>
                    <div id="radioBtn" class="btn-group"
                        *ngIf="(isTitanEnabled && !isBetaEnabled) && changeMemberPreferencesPermission">
                        <input [id]="'EnableAmazonSubscriptionYes'+fboid" (click)="enableAmazonSubscription(true)"
                            value='Yes' [attr.name]="'amazonSubscription'+fboid" type="radio"
                            [checked]="fboProfileDetail.amazonSubscription === 'Yes'">
                        <label [attr.for]="'EnableAmazonSubscriptionYes'+fboid"
                            class="btn btn-primary btn-xs">{{'customer-service.Yes' | translate | translateKey}}</label>
                        <input [id]="'EnableAmazonSubscriptionNo'+fboid" (click)="enableAmazonSubscription(false)"
                            value='No' [attr.name]="'amazonSubscription'+fboid" type="radio"
                            [checked]="fboProfileDetail.amazonSubscription === 'No'">
                        <label [attr.for]="'EnableAmazonSubscriptionNo'+fboid"
                            class="btn btn-primary btn-xs">{{'customer-service.No' | translate | translateKey}}</label>
                    </div>
                    <div class="col-md-2 no-padding text-right" *ngIf="!(isTitanEnabled && !isBetaEnabled)">
                        {{'customer-service.NA'
                        |translate | translateKey}} </div>
                    <div class="col-md-2 no-padding text-right"
                        *ngIf="((isTitanEnabled && !isBetaEnabled) && !changeMemberPreferencesPermission)">
                        {{'customer-service.'+fboProfileDetail.amazonSubscription |translate | translateKey}} </div>
                </div>
                <div class="row" *ngIf="isMemberTypeDistributor && hasRetailSubscriptionAccess && isStoreRetailSubscriptionEnabled &&
                (!enableAmazonSubscriptionFlag)">
                    <div class="col-md-10 no-padding">
                        {{'customer-service.Shared Retail Subscriber?' | translate | translateKey}}
                    </div>
                    <div class="col-md-2 no-padding text-right">
                        <span
                            *ngIf="memberRetailSubscriptionDetail && memberRetailSubscriptionDetail.subscriptionStatus
                            == subscriptionStatusEnum.Active">{{'customer-service.Yes' |translate |translateKey }}</span>
                            <span
                            *ngIf="(memberRetailSubscriptionDetail && !(memberRetailSubscriptionDetail?.subscriptionStatus
                            == subscriptionStatusEnum.Active))">{{'customer-service.No' |translate |translateKey }}</span>
                    </div>
                </div>
            </div>
            <div class="pad-bottom-15"
                *ngIf="businessViewEntityPermission && (isTitanEnabled && !isBetaEnabled) && isDistributor && !disableBusinessEntityForFbo">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.BUSINESS ENTITY' |translate|translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Name' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span
                            *ngIf="fboBusinessEntity.businessEntityName">{{fboBusinessEntity.businessEntityName}}</span>
                        <span *ngIf="!fboBusinessEntity.businessEntityName">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Address' |translate |translateKey}}
                    </div>
                    <div *ngIf="!fboBusinessEntity.addressLine1" class="col-md-6 no-padding text-right">
                        <span *ngIf="!fboBusinessEntity.addressLine1">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                    <div *ngIf="fboBusinessEntity.addressLine1" class="col-md-6 no-padding text-right">
                        <span>{{fboBusinessEntity.addressLine1}}</span>
                    </div>
                    <div *ngIf="fboBusinessEntity.addressLine2" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboBusinessEntity.addressLine2}}</span>
                    </div>
                    <div *ngIf="fboBusinessEntity.city" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span *ngIf="fboBusinessEntity.city">{{fboBusinessEntity.city}}</span>
                    </div>
                    <div *ngIf="businessEntityState" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span *ngIf="businessEntityState">{{businessEntityState}}</span>
                    </div>
                    <div *ngIf="businessEntityCountry" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span *ngIf="businessEntityCountry">{{businessEntityCountry}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Entity ID Last 4' |translate |translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span
                            *ngIf="fboBusinessEntity.businessEntityId">{{fboBusinessEntity.businessEntityId.slice(-4)}}</span>
                        <span *ngIf="!fboBusinessEntity.businessEntityId">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Active status' |translate |translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span
                            *ngIf="fboBusinessEntity.status && fboBusinessEntity.status==1">{{'customer-service.Active'
                            |translate | translateKey}}
                        </span>
                        <span
                            *ngIf="fboBusinessEntity.status && fboBusinessEntity.status==2">{{'customer-service.Inactive'
                            |translate | translateKey}}
                        </span>
                        <span *ngIf="!fboBusinessEntity.status">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Effective Dates' |translate |translateKey}}
                    </div>
                    <div *ngIf="fboBusinessEntity.startDate" class="col-md-6 no-padding text-right">
                        <span>{{fboBusinessEntity.startDate}}</span>
                    </div>
                    <!-- <div *ngIf="fboBusinessEntity.startDate && fboBusinessEntity.endDate" class="col-md-6 col-md-offset-6 no-padding text-center">
                        <span>to</span>
                    </div>
                    <div *ngIf="fboBusinessEntity.endDate" class="col-md-6 col-md-offset-6 no-padding text-right">
                        <span>{{fboBusinessEntity.endDate}}</span>
                    </div> -->
                    <div *ngIf="!(fboBusinessEntity.startDate)" class="col-md-6 no-padding text-right">
                        <span>{{'customer-service.NA'|translate | translateKey}}</span>
                    </div>
                </div>

            </div>
            <div class="pad-bottom-15">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.SPONSOR INFORMATION' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Name' |translate}}
                    </div>
                    <div class="col-md-9 no-padding text-right">
                        <a class="pointerstyle"
                            (keyup.enter)="navigateToFBOProfile(fboProfileDetail.sponsorDetails.fboId, memberType, fboProfileDetail.sponsorDetails.firstName,fboProfileDetail?.sponsorDetails.lastName,fboProfileDetail?.sponsorDetails?.memberLevelID)"
                            (click)="navigateToFBOProfile(fboProfileDetail.sponsorDetails.fboId, memberType, fboProfileDetail.sponsorDetails.firstName,fboProfileDetail?.sponsorDetails.lastName,fboProfileDetail?.sponsorDetails?.memberLevelID)">
                            <span
                                *ngIf="fboProfileDetail && fboProfileDetail.sponsorDetails">{{fboProfileDetail.sponsorDetails.firstName
                                | titlecase}}
                                {{fboProfileDetail.sponsorDetails.lastName?
                                (' '+fboProfileDetail.sponsorDetails.lastName):'' | titlecase}}</span></a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Sponsor ID' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <a class="pointerstyle"
                            (keyup.enter)="navigateToFBOProfile(fboProfileDetail.sponsorDetails.fboId, memberType, fboProfileDetail.sponsorDetails.firstName, fboProfileDetail?.sponsorDetails.lastName, fboProfileDetail?.sponsorDetails?.memberLevelID)"
                            (click)="navigateToFBOProfile(fboProfileDetail.sponsorDetails.fboId,memberType, fboProfileDetail.sponsorDetails.firstName, fboProfileDetail?.sponsorDetails.lastName, fboProfileDetail?.sponsorDetails?.memberLevelID)">
                            <span
                                *ngIf="fboProfileDetail && fboProfileDetail.sponsorDetails">{{fboProfileDetail.sponsorDetails.fboId
                                |distributorIdFormat}}</span></a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Email' |translate | translateKey}}
                    </div>
                    <div class="col-md-9 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.sponsorDetails">{{fboProfileDetail.sponsorDetails.emailId}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.Phone' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.sponsorDetails && phoneNumberFormat">{{fboProfileDetail.sponsorDetails.mobile
                            | mask: phoneNumberFormat}}</span>
                    </div>
                </div>
            </div>
            <div class="pad-bottom-15 hide">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue"> {{'customer-service.FIRST UPLINE INFORMATION' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Name' |translate | translateKey}}
                    </div>
                    <div class="col-md-9 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager && fboProfileDetail.firstActiveUplineManager.firstName">
                            {{fboProfileDetail.firstActiveUplineManager.firstName | titlecase}}
                            {{fboProfileDetail.firstActiveUplineManager.lastName?
                            (' '+fboProfileDetail.sponsorDetails.lastName):'' | titlecase}}
                        </span>
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager && !fboProfileDetail.firstActiveUplineManager.firstName">{{'customer-service.NA'
                            |translate | translateKey}}</span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 no-padding">
                        {{'customer-service.FBO ID' |translate | translateKey}}
                    </div>
                    <div class="col-md-6 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager && fboProfileDetail.firstActiveUplineManager.fboId">{{fboProfileDetail.firstActiveUplineManager.fboId
                            |distributorIdFormat}}
                        </span>
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager && !fboProfileDetail.firstActiveUplineManager.fboId">{{'customer-service.NA'
                            |translate | translateKey}}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Email' |translate | translateKey}}
                    </div>
                    <div class="col-md-9 no-padding text-right">
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager &&fboProfileDetail.firstActiveUplineManager.emailId">
                            <a href="mailto:{{fboProfileDetail.firstActiveUplineManager.emailId}}">{{fboProfileDetail.firstActiveUplineManager.emailId
                                | lowercase}}</a>
                        </span>
                        <span
                            *ngIf="fboProfileDetail && fboProfileDetail.firstActiveUplineManager &&!fboProfileDetail.firstActiveUplineManager.emailId">{{'customer-service.NA'
                            |translate | translateKey}}</span>

                    </div>
                </div>
            </div>
            <div class="pad-bottom-15">
                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.SPOUSE INFORMATION' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 no-padding">
                        {{'customer-service.Name' |translate | translateKey}}
                    </div>
                    <div class="col-md-9 no-padding text-right">
                        <span *ngIf="fboProfileDetail.spouseFullName">{{fboProfileDetail.spouseFullName |
                            titlecase}}</span>
                        <span *ngIf="!fboProfileDetail.spouseFullName">{{'customer-service.NA' |translate |
                            translateKey}}</span>
                    </div>
                </div>
            </div>
            <div class="pad-bottom-15">

                <div class="row">
                    <div class="no-padding">
                        <span class="color-blue">{{'customer-service.STORE ELIGIBILITY' |translate |
                            translateKey}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 no-padding text-justify">
                        <span *ngIf="fboProfileDetail.storeEligibility">{{fboProfileDetail.storeEligibility |
                            titlecase}}
                        </span>
                        <span *ngIf="!fboProfileDetail.storeEligibility">{{'customer-service.NA' |translate |
                            translateKey}}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="col-md-5 right-padding-0">
        <ul class="list-group profileInfo-list-group" *ngIf="showCCSnapshotSection">
            <li class="list-group-item clearfix">
                <div class="col-xs-6 no-padding">
                    <span class="header-font">
                        {{'customer-service.CC Snapshot' |translate | translateKey}}
                    </span>
                </div>
                <div class="col-xs-6" *ngIf="ccSnapshot.list.length">
                    <div class="row">
                        <span class="pull-right header-font">
                            {{ccSnapshot?.currentMonthTotal | number:'1.3-3'}}</span>
                    </div>
                    <div class="row">
                        <span class="pull-right">{{'customer-service.Monthly Total' |translate | translateKey}}</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item">
                <div class="table-responsive">
                    <table class="table">
                        <tbody *ngIf="ccSnapshot.list.length">
                            <tr *ngFor="let item of ccSnapshot.list">
                                <td width="60%">{{item.ccKey}}</td>
                                <td width="20%" [ngClass]="{'colblue': item?.ccKey==''}"
                                    title="{{item?.ccKey==('customer-service.Level'|translate | translateKey) ? (item?.currentMonthTitle|titlecase) :''}}">
                                    <ng-container *ngIf="(item?.ccKey==('customer-service.4CC Active'|translate | translateKey)); else not4CC">
                                        {{((item?.currentMonthValue|titlecase) == (commonConstants.YES|titlecase)) ? ('customer-service.Yes'|translate | translateKey) : ('customer-service.No'|translate | translateKey)}}
                                    </ng-container>
                                    <ng-template #not4CC>
                                        {{(item?.ccKey==''  || item?.ccKey==('customer-service.Level'|translate | translateKey)) ? (item?.currentMonthValue) : (item?.currentMonthValue | number:'1.3-3') }}
                                    </ng-template>
                                </td>
                                <td width="20%" [ngClass]="{'colblue': item?.ccKey==''}"
                                    title="{{item?.ccKey==('customer-service.Level'|translate | translateKey) ? (item?.previousMonthTitle|titlecase) :''}}">
                                    <ng-container *ngIf="item?.ccKey==('customer-service.4CC Active'|translate | translateKey); else not4CC1 ">
                                        {{((item?.previousMonthValue|titlecase) == (commonConstants.YES|titlecase)) ? ('customer-service.Yes'|translate | translateKey) : ('customer-service.No'|translate | translateKey) }}
                                    </ng-container>
                                    <ng-template #not4CC1>
                                        {{(item?.ccKey=='' || item?.ccKey==('customer-service.Level'|translate | translateKey))  ? (item?.previousMonthValue) : (item?.previousMonthValue | number:'1.3-3') }}
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="isLoading">
                            <tr>
                                <td colspan="3" class="text-center">{{'customer-service.Loading Results, Please wait.'
                                    |translate | translateKey}}.</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="!isLoading && ccSnapshot.list.length === 0">
                            <tr>
                                <td colspan="3" class="text-center">{{'customer-service.No record(s) found' |translate
                                    | translateKey}}.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
            <li class="list-group-item">
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td width="60%" class="bold"> {{'customer-service.Total Global CC' |translate |
                                    translateKey}} {{'customer-service.YTD' |translate }} </td>
                                <td width="40%"> {{ccSnapshot.globalCC | number:'1.3-3'}} </td>
                            </tr>
                            <tr>
                                <td width="60%" class="bold"> {{'customer-service.Recognized Manager' |translate |
                                    translateKey}} </td>
                                <td width="40%"> {{ccSnapshot.totMgrCount}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>
        <ul *ngIf="autoshipPermission" class="list-group profileInfo-list-group">
            <li class="list-group-item clearfix">
                <div class="col-xs-6 no-padding">
                    <span class="header-font">
                        {{'customer-service.Autoship' |translate | translateKey}}
                    </span>
                </div>
                <div class="col-xs-6">
                    <div class="row" *ngIf="activeAutoShipInfo.length > 0">
                        <span class="pull-right header-font"> {{'customer-service.ON' |translate | translateKey}}</span>
                    </div>
                    <div class="row" *ngIf="activeAutoShipInfo.length == 0">
                        <span class="pull-right header-font">{{'customer-service.OFF' |translate | translateKey}}</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item">
                <div class="table-responsive orderdetails-table">
                    <!-- slimScroll width="auto" height="auto" style="max-height:250px"-->
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="20%">
                                    {{'customer-service.Name' |translate | translateKey}}
                                </th>
                                <th width="20%">
                                    {{'customer-service.Next Autoship Run Date' |translate | translateKey}}
                                </th>
                                <th width="20%">
                                    {{'customer-service.Frequency' |translate | translateKey}}
                                </th>
                                <th width="20%">
                                    {{'customer-service.Account Number' |translate | translateKey}}
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="activeAutoShipInfo.length > 0">

                            <tr *ngFor="let autoship of activeAutoShipInfo">
                                <td>{{autoship.name}}</td>
                                <td *ngIf="autoship.autoShipDisplayDate">{{autoship.autoShipDisplayDate | date:
                                    'dd-MMM-yyyy'}}</td>
                                <td *ngIf="!autoship.autoShipDisplayDate">{{autoship.startDate | date: 'dd-MMM-yyyy'}}
                                </td>
                                <td>Monthly</td>
                                <td *ngIf="autoship.autoshipPayments.length > 0">
                                    {{autoship.autoshipPayments[0].maskedCardNum}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="activeAutoShipInfo.length === 0 && inactiveAutoShipInfo.length === 0">
                            <tr>
                                <td colspan="4" class="text-center">{{'customer-service.No Autoship(s)' |translate |
                                    translateKey}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="inactiveAutoShipInfo.length > 0">
                            <tr>
                                <td colspan="4" class="text-center">{{inactiveAutoShipInfo.length}}
                                    {{'customer-service.Autoship(s) found in Inactive Status'
                                    |translate}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>
        <ul *ngIf="fboPaymentPermission" class="list-group profileInfo-list-group">
            <li class="list-group-item clearfix">
                <div class="col-xs-6 no-padding">
                    <span class="header-font">
                        {{'customer-service.Credit Cards' |translate | translateKey}}
                    </span>
                </div>
                <div class="col-xs-6">
                    <div class="row">
                        <span class="pull-right header-font">{{distributorDefaultCardPaymentInfo.length}}</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item">
                <div class="table-responsive orderdetails-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="20%">
                                    {{'customer-service.Type' |translate | translateKey}}
                                </th>
                                <th width="25%">
                                    {{'customer-service.Card Number' |translate | translateKey}}
                                </th>
                                <th width="15%">
                                    {{'customer-service.Expiry' |translate | translateKey}}
                                </th>
                                <th width="20%">
                                    {{'customer-service.Notes'|translate | translateKey}}
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="distributorDefaultCardPaymentInfo.length>0">
                            <tr *ngFor="let CardPaymentInfo of distributorDefaultCardPaymentInfo">
                                <td>{{CardPaymentInfo.cardType}}</td>
                                <td>Ending in {{CardPaymentInfo.maskedCard | slice:-4}}</td>
                                <td *ngIf="CardPaymentInfo.expiryMonth && CardPaymentInfo.expiryYear">
                                    <span><span
                                            *ngIf="CardPaymentInfo.expiryMonth < 10">0</span>{{CardPaymentInfo.expiryMonth}}/{{CardPaymentInfo.expiryYear.toString().substring(2,4)}}</span>
                                </td>
                                <td [ngClass]="{'color-red':CardPaymentInfo.expired}">{{CardPaymentInfo.notes}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="distributorDefaultCardPaymentInfo.length ==0">
                            <tr>
                                <td colspan="4" class="text-center">{{'customer-service.No CreditCard(s)' |translate |
                                    translateKey}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>


        <ul *ngIf="fboPaymentPermission" class="list-group profileInfo-list-group">
            <li class="list-group-item clearfix">
                <div class="col-xs-6 no-padding">
                    <span class="header-font">
                        {{'customer-service.Checking Accounts' |translate | translateKey}}
                    </span>
                </div>
                <div class="col-xs-6">
                    <div class="row">
                        <span class="pull-right header-font">{{paymentComponentSettings.savedAchs?.length}}</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item">
                <div class="table-responsive echeck-list orderdetails-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="20%">
                                    {{'customer-service.Account Type' |translate | translateKey}}
                                </th>
                                <th width="25%">
                                    {{'customer-service.Account Number' |translate | translateKey}}
                                </th>
                                <th width="15%">
                                    {{'customer-service.Routing Number' | translate | translateKey}}
                                </th>
                                <th width="15%">
                                    {{'customer-service.Auth Form Received' | translate | translateKey}}
                                </th>

                            </tr>
                        </thead>
                        <tbody *ngIf="distributorDefaultECheckPaymentInfo?.length">
                            <tr *ngFor="let ECheckPaymentInfo of distributorDefaultECheckPaymentInfo">
                                <td><span
                                        *ngIf="ECheckPaymentInfo.accountType">{{fetchEcheckSecTypes(ECheckPaymentInfo.secType)}}</span>
                                </td>
                                <td><span *ngIf="ECheckPaymentInfo.accountNumber">Ending with
                                        {{ECheckPaymentInfo.accountNumber.substr(ECheckPaymentInfo.accountNumber.length-4)}}</span>
                                </td>
                                <td><span
                                        *ngIf="ECheckPaymentInfo.routingNumber">{{ECheckPaymentInfo.routingNumber}}</span>
                                </td>
                                <td><span>
                                        <div id="radioBtn" class="btn-group">
                                            <input [id]="'echeckYes' + ECheckPaymentInfo.id"
                                                [attr.disabled]="ECheckPaymentInfo.secType === 'WEB'?true:null"
                                                (click)="enableAuthFormReceiving(true,ECheckPaymentInfo.id)" value='Yes'
                                                [attr.name]="ECheckPaymentInfo.id" type="radio"
                                                [checked]="ECheckPaymentInfo.verified">
                                            <label [attr.for]="'echeckYes'+ ECheckPaymentInfo.id"
                                                class="btn btn-primary btn-xs">{{'customer-service.Yes' | translate |
                                                translateKey}}</label>
                                            <input [id]="'echeckNo'+ ECheckPaymentInfo.id"
                                                [attr.disabled]="ECheckPaymentInfo.secType === 'WEB'?true:null"
                                                (click)="enableAuthFormReceiving(false,ECheckPaymentInfo.id)" value='No'
                                                [attr.name]="ECheckPaymentInfo.id" type="radio"
                                                [checked]="!ECheckPaymentInfo.verified">
                                            <label [attr.for]="'echeckNo'+ ECheckPaymentInfo.id"
                                                class="btn btn-primary btn-xs">{{'customer-service.No' | translate |
                                                translateKey}}</label>
                                        </div>
                                    </span>
                                </td>
                                <td>
                                    <a tabindex="0" class="link--light" (click)="editEcheck(ECheckPaymentInfo)"
                                        (keyup.enter)="editEcheck(ECheckPaymentInfo)"
                                        *ngIf="hasAllowEcheckPermission && showPayByAccountCheck  && (ECheckPaymentInfo.secType === 'TEL')">
                                        <!-- <span class="">{{'checkout.Edit' | translate | translateKey}} </span> -->
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                </td>
                        </tbody>
                        <tbody *ngIf="!distributorDefaultECheckPaymentInfo">
                            <tr>
                                <td colspan="4" class="text-center">{{'customer-service.No E-Check(s)' |translate |
                                    translateKey}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </li>
        </ul>
    </div>

</section>

<div style="display: none;" id="ckeditor-content"></div>

<modal #bondedWarehouseProjectModal [closeOnEscape]="false" [closeOnOutsideClick]="false">
    <modal-header>
        <div class="color-blue">{{'customer-service.Bonded Warehouse Project' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="fboProfileDetail" class="distributorInfo">
            <div>
                <span class="header-font bold">{{fboProfileDetail | displayNameFormat}}</span>
            </div>
            <div *ngIf="fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR"
                class="bold">
                <span>{{fboProfileDetail.displayName | titlecase}}</span>
            </div>
            <div>
                <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"
                        [copyToClipboard]="fboProfileDetail.fboId"></i></a>
                <span>{{fboProfileDetail.fboId |distributorIdFormat}} </span>
                <span *ngIf="fboProfileDetail.memberLevel"> | </span>
                <span>{{fboProfileDetail.memberLevel | titlecase}}</span>
            </div>
        </div>
        <div class="row bwp-container">
            <div class="col-md-6 mb-10">
                <input tabindex="0" type="checkbox" [(ngModel)]="bondedWarehouseProjectSelected"
                    [checked]="bondedWarehouseProjectSelected"
                    [attr.disabled]="(!this.bondedWarehouseProjectManagePermission || disableBondedWarehouseProject)? '':null">
                <label>
                    &nbsp;{{'customer-service.Enabled for Bonded Warehouse Project' |translate }}
                </label>
            </div>
        </div>
        <div class="clearboth pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="button" (click)="submitBondedWarehouseProject()"
                [attr.disabled]="((!this.bondedWarehouseProjectManagePermission || disableBondedWarehouseProject) || (this.prevBondedWarehouseProjectSelected === this.bondedWarehouseProjectSelected))? '':null">
                {{'config-system.SUBMIT' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeBWPModal()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>

<!-- BWP disabled popup starts for Business Entity-->
<modal #bwpConfirmationModal  [closeOnEscape]="false" [closeOnOutsideClick]="false">
    <modal-content>
        <div class="">{{'customer-service.If you add VAT ID/Business Entity ID, Bonded Warehouse Project will be disabled?' |translate|translateKey}}</div>
        <div class="clearboth text-right mt-40" id="bwpDisablePopUp">
            <button class="btn blue-button" tabindex="0" type="button" (click)="submitBWPConformation()">
                {{'config-system.OK' |translate |translateKey}}
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="cancelBWPConformation()">
                {{'config-system.CANCEL' |translate |translateKey}}
            </button>
        </div>
    </modal-content>
</modal>
<!--  BWP disabled popup starts Business Entity-->




// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/fboprofile.component.html